"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const de_1 = require("../../../backend/src/app/acl_module/config/i18n/de");
const de_2 = __importDefault(require("./landing/de"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./de/tools_aiFormAnalyzer"));
const tutorial_todos_1 = __importDefault(require("./de/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./de/tutorial_statistics"));
const tutorial_form_1 = __importDefault(require("./de/tutorial_form"));
const tutorial_list_1 = __importDefault(require("./de/tutorial_list"));
const de = {
    ...de_2.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...tutorial_form_1.default,
    ...tutorial_list_1.default,
    // General
    "onboarding.tooltip.view": "Onboarding-Details anzeigen",
    "onboarding.tooltip.edit": "Onboarding-Eintrag bearbeiten",
    "onboarding.tooltip.delete": "Onboarding-Eintrag löschen",
    "acl_resource.knowledge_group": "Wissensgruppe",
    "acl_resource.payment": "Zahlung",
    "acl_resource.botTest": "Bot Test",
    "app.title": "Inthub Plattform",
    "app.page.login_page": "Anmeldung",
    "app.page.registration_page": "Registrierung",
    "app.removed": "Entfernt",
    "app.intext.code": "CODE",
    "app.share": "Teilen",
    "app.share_link": "Link teilen",
    "app.co_share": "Mit Benutzern teilen",
    "modal.share.title": "Inhalte teilen",
    "modal.settings.title": "Chat-Einstellungen",
    "app.loading": "Laden...",
    "app.save": "Speichern",
    "app.cancel": "Abbrechen",
    "app.delete": "Löschen",
    "app.edit": "Bearbeiten",
    "app.create": "Erstellen",
    "app.update": "Aktualisieren",
    "app.search": "Suchen",
    // Slot-Optionen
    "slot.none": "Keine",
    "slot.goal.efficiency": "Effizienz",
    "slot.goal.accuracy": "Genauigkeit",
    "slot.goal.creativity": "Kreativität",
    "slot.goal.detail": "Detail",
    "slot.target.client": "Kunde",
    "slot.target.coworker": "Kollege",
    "slot.target.manager": "Manager",
    "slot.target.self": "Ich",
    "slot.format.pdf": "PDF",
    "slot.format.csv": "CSV",
    // Slot placeholders
    "slot.prompt_context": "Thema",
    "slot.conversation_goal": "Gesprächsziel",
    "slot.conversation_target": "Zielgruppe",
    "slot.conversation_format": "Ausgabeformat",
    // Slot data management
    "slotData.create.success": "Slot-Daten erfolgreich erstellt",
    "slotData.create.error": "Fehler beim Erstellen der Slot-Daten",
    "slotData.load.error": "Fehler beim Laden der Slot-Daten",
    "slotData.form.label": "Bezeichnung",
    "slotData.form.value": "Wert",
    "slotData.form.type": "Typ",
    "slotData.type.target": "Ziel",
    "slotData.type.goal": "Aufgabe",
    "slot-data.created": "Slot-Daten erfolgreich erstellt",
    "slot-data.deleted": "Slot-Daten erfolgreich gelöscht",
    "app.reset": "Zurücksetzen",
    "app.confirm": "Bestätigen",
    "app.close": "Schließen",
    "app.next": "Weiter",
    "app.previous": "Zurück",
    "app.submit": "Absenden",
    "app.actions": "Aktionen",
    "app.required": "Erforderlich",
    "app.optional": "Optional",
    "app.success": "Erfolg",
    "app.error": "Fehler",
    "app.warning": "Warnung",
    "app.info": "Info",
    // Chat
    "chat.entry.reasoning": "Begründung",
    // Navigation & Menu
    "nav.home": "Startseite",
    "nav.settings": "Einstellungen",
    "nav.management": "Verwaltung",
    "nav.avatar": "Avatar",
    "nav.logout": "Abmelden",
    "nav.login": "Anmelden",
    "nav.register": "Registrieren",
    "nav.language": "Sprache",
    // Language names
    "lang.en": "Englisch",
    "lang.de": "Deutsch",
    "lang.es": "Spanisch",
    "lang.it": "Italienisch",
    "lang.pl": "Polnisch",
    "lang.zh": "Chinesisch",
    // Auth
    "auth.login": "Anmelden",
    "auth.logout": "Abmelden",
    "auth.register": "Registrieren",
    "auth.username": "Benutzername",
    "auth.password": "Passwort",
    "auth.confirmPassword": "Passwort bestätigen",
    "auth.email": "E-Mail",
    "auth.rememberMe": "Angemeldet bleiben",
    "auth.forgotPassword": "Passwort vergessen?",
    "auth.noAccount": "Noch kein Konto?",
    "auth.haveAccount": "Bereits ein Konto?",
    // User
    "user.list": "Benutzerliste",
    "user.create": "Benutzer erstellen",
    "user.edit": "Benutzer bearbeiten",
    "user.delete": "Benutzer löschen",
    "user.name": "Name",
    "user.last_name": "Nachname",
    "user.username": "Benutzername",
    "user.email": "E-Mail",
    "user.parent": "Übergeordneter Benutzer",
    "user.role": "Rolle",
    "user.roles.super_admin": "Super Admin",
    "user.roles.parent_user": "Manager",
    "user.roles.enterprise": "Unternehmen",
    "user.roles.user": "Benutzer",
    "user.grade.title": "Konto Upgraden",
    "user.grade.free": "Kostenlos",
    "user.grade.basic": "Basic",
    "user.grade.pro": "Pro",
    "user.grade.ultra": "Ultra",
    "user.status": "Status",
    "user.company": "Unternehmen",
    "user.active": "Aktiv",
    "user.inactive": "Inaktiv",
    // User list component (for non-admin users)
    "userList.title": "Teammitglieder",
    "userList.description": "Vernetzen und arbeiten Sie mit Ihren Teammitgliedern zusammen",
    "userList.searchPlaceholder": "Teammitglieder suchen...",
    "userList.noUsers": "Keine Teammitglieder gefunden",
    "userList.loading": "Teammitglieder werden geladen...",
    "userList.online": "Online",
    "userList.offline": "Offline",
    "userList.lastSeen": "Zuletzt gesehen",
    "userList.startChat": "Chat starten",
    "userList.viewProfile": "Profil anzeigen",
    // User Group
    "userGroup.name": "Name",
    "userGroup.description": "Beschreibung",
    "userGroup.active": "Aktiv",
    "userGroup.owner": "Eigentümer",
    "userGroup.userCount": "Benutzeranzahl",
    "userGroup.listTitle": "Benutzergruppen",
    "userGroup.addUserGroup": "Benutzergruppe hinzufügen",
    "userGroup.searchPlaceholder": "Benutzergruppen suchen...",
    "userGroup.form.title.edit": "Benutzergruppe bearbeiten",
    "userGroup.form.title.add": "Benutzergruppe hinzufügen",
    "userGroup.form.back": "Zurück",
    "userGroup.form.name.label": "Gruppenname",
    "userGroup.form.name.placeholder": "Gruppenname eingeben",
    "userGroup.form.description.label": "Beschreibung",
    "userGroup.form.description.placeholder": "Gruppenbeschreibung eingeben",
    "userGroup.form.active.label": "Aktiv",
    "userGroup.form.acl.label": "Zugriffskontrolle",
    "userGroup.form.acl.description": "Zugriffsberechtigungen für diese Benutzergruppe konfigurieren",
    "userGroup.form.submit.update": "Benutzergruppe aktualisieren",
    "userGroup.form.submit.create": "Benutzergruppe erstellen",
    "userGroup.form.saved": "Benutzergruppe erfolgreich gespeichert",
    "userGroup.form.error.save": "Fehler beim Speichern der Benutzergruppe",
    "userGroup.create": "Benutzergruppe erstellen",
    "userGroup.error.create": "Fehler beim Erstellen der Benutzergruppe",
    "user.form.userGroup.label": "Benutzergruppe",
    "user.form.userGroup.placeholder": "Benutzergruppe auswählen",
    "user.form.userGroup.show": "Benutzergruppen anzeigen",
    "user.form.userGroup.add": "Neue Benutzergruppe hinzufügen",
    "user.form.userGroup.search_placeholder": "Benutzergruppen suchen...",
    // User form
    "user.form.title.edit": "Benutzer bearbeiten",
    "user.form.title.add": "Benutzer hinzufügen",
    "user.form.back": "Zurück",
    // Gender
    "gender.male": "Männlich",
    "gender.female": "Weiblich",
    "user.form.name.label": "Name",
    "user.form.name.placeholder": "Max",
    "user.form.last_name.label": "Nachname",
    "user.form.last_name.placeholder": "Mustermann",
    "user.form.username.label": "Login",
    "user.form.username.placeholder": "maxmustermann",
    "user.form.email.label": "E-Mail",
    "user.form.email.placeholder": "email@adresse.com",
    "user.form.language.label": "Sprache",
    "user.form.language.placeholder": "Sprache auswählen",
    "user.form.password.label": "Passwort",
    "user.form.password.new.label": "Neues Passwort (leer lassen, um aktuelles zu behalten)",
    "user.form.password.placeholder": "Passwort",
    "user.form.password.repeat.label": "Passwort wiederholen",
    "user.form.password.repeat.new.label": "Passwort wiederholen (leer lassen, um aktuelles zu behalten)",
    "user.form.password.repeat.placeholder": "Passwort wiederholen",
    "user.form.role.label": "Rolle",
    "user.form.role.placeholder": "Rolle auswählen",
    "user.form.active.label": "Aktiv",
    "user.form.companies.label": "Zugewiesene Firmen",
    "user.form.companies.placeholder": "Firmen auswählen",
    "user.form.company.label": "Firma",
    "user.form.company.placeholder": "Firma auswählen...",
    "user.form.submit.update": "Benutzer aktualisieren",
    "user.form.submit.create": "Benutzer erstellen",
    "user.form.acl.loadError": "Fehler beim Laden der ACL-Metadaten:",
    "user.form.load.debug": "Lade Benutzer:",
    "user.form.load.error": "Fehler beim Laden des Benutzers",
    "user.form.submit.updateError": "Fehler beim Aktualisieren des Benutzers",
    "user.form.submit.createError": "Fehler beim Erstellen des Benutzers",
    "user.form.submit.updateSuccess": "Benutzer erfolgreich aktualisiert",
    "user.form.submit.createSuccess": "Benutzer erfolgreich erstellt",
    // User form preview
    "user.form.preview.title": "Zugriffs-Vorschau",
    "user.form.preview.selectedGroup": "Ausgewählte Gruppe",
    "user.form.preview.permissions": "Berechtigungen",
    "user.form.preview.selectGroup": "Wählen Sie eine Benutzergruppe aus, um die Zugriffsberechtigungen zu sehen",
    "user.form.preview.noAccess": "Keine Zugriffsberechtigungen verfügbar",
    // User form errors
    "user.form.error.userGroup_required": "Die Auswahl einer Benutzergruppe ist erforderlich",
    // User profile
    "user.profile.title": "Profil bearbeiten",
    "user.profile.back": "Zurück zum Dashboard",
    "user.profile.name.label": "Vollständiger Name",
    "user.profile.name.placeholder": "Max Mustermann",
    "user.profile.username.label": "Benutzername",
    "user.profile.username.placeholder": "maxmustermann",
    "user.profile.email.label": "E-Mail",
    "user.profile.email.placeholder": "email@adresse.de",
    "user.profile.picture.label": "Profilbild",
    "user.profile.picture.placeholder": "Profilbild auswählen...",
    "user.profile.picture.remove": "×",
    "user.profile.changePassword.title": "Passwort ändern",
    "user.profile.changePassword.description": "Lassen Sie die Passwort-Felder leer, wenn Sie Ihr Passwort nicht ändern möchten.",
    "user.profile.password.new.label": "Neues Passwort",
    "user.profile.password.placeholder": "Neues Passwort eingeben",
    "user.profile.password.repeat.label": "Neues Passwort wiederholen",
    "user.profile.password.repeat.placeholder": "Neues Passwort wiederholen",
    "user.profile.submit": "Profil aktualisieren",
    "user.profile.form.passwordMismatch": "Passwörter stimmen nicht überein",
    "user.profile.form.updateFailed": "Fehler beim Aktualisieren des Profils",
    "user.profile.form.updateSuccess": "Profil erfolgreich aktualisiert",
    "route.userGroup.list": "Benutzergruppen",
    "route.userGroup.create": "Benutzergruppe hinzufügen",
    "route.userGroup.edit": "Benutzergruppe bearbeiten",
    "route.user_group.list": "Benutzergruppen",
    "route.user_group.create": "Benutzergruppe hinzufügen",
    // Company
    "company.list": "Firmenliste",
    "company.create": "Firma erstellen",
    "company.edit": "Firma bearbeiten",
    "company.delete": "Firma löschen",
    "company.name": "Name",
    "company.nip": "USt-IdNr.",
    "company.email": "E-Mail",
    "company.phone": "Telefon",
    "company.city": "Stadt",
    "company.address": "Adresse",
    "company.street": "Straße",
    "company.postalCode": "Postleitzahl",
    "company.website": "Website",
    "company.description": "Beschreibung",
    "company.modules": "Module",
    "company.active": "Aktiv",
    // Company Preview & Tooltips
    "company.preview.title": "Firmendetails",
    "company.preview.failedToLoad": "Fehler beim Laden der Firmeninformationen",
    "company.preview.noCompany": "Keine Firmeninformationen verfügbar",
    "company.preview.section.basic_info": "Grundinformationen",
    "company.preview.section.status": "Status",
    "company.preview.section.location": "Standort",
    "company.preview.section.additional": "Zusätzliche Informationen",
    "company.tooltips.preview": "Firmendetails anzeigen",
    // Company form
    "company.form.title.edit": "Firma bearbeiten",
    "company.form.title.add": "Firma hinzufügen",
    "company.form.back": "Zurück",
    "company.form.name.label": "Firmenname",
    "company.form.name.placeholder": "Firmenname eingeben",
    "company.form.nip.label": "USt-IdNr.",
    "company.form.nip.placeholder": "123-456-78-90",
    "company.form.email.label": "E-Mail",
    "company.form.email.placeholder": "adresse@email.com",
    "company.form.phone.label": "Telefon",
    "company.form.phone.placeholder": "123 456 789",
    "company.form.address.label": "Adresse",
    "company.form.street.placeholder": "Straße und Hausnummer",
    "company.form.postal_code.placeholder": "Postleitzahl",
    "company.form.city.placeholder": "Stadt",
    "company.form.website.label": "Website",
    "company.form.website.placeholder": "https://firma.com",
    "company.form.description.label": "Beschreibung",
    "company.form.description.placeholder": "Firmenbeschreibung",
    "company.form.active.label": "Aktiv",
    "company.form.logo.label": "Firmenlogo",
    "company.form.logo.placeholder": "Firmenlogo auswählen",
    "company.form.submit.update": "Aktualisieren",
    "company.form.submit.create": "Speichern",
    "company.form.submit.createCompanyData": "Firmendaten speichern",
    "company.form.acl.loadError": "Fehler beim Laden der ACL-Metadaten:",
    "company.form.load.error": "Fehler beim Laden der Firma",
    "company.form.submit.updateError": "Fehler beim Aktualisieren der Firma",
    "company.form.submit.createError": "Fehler beim Erstellen der Firma",
    "company.form.submit.updateSuccess": "Firma erfolgreich aktualisiert",
    "company.form.submit.createSuccess": "Firma erfolgreich erstellt",
    // Access Settings Columns
    "access.user_or_company": "Benutzer / Unternehmen",
    "access.user_group": "Benutzergruppe",
    "access.policies": "Zugriffsrichtlinien",
    "access.active": "Aktiv",
    "access.status.active": "Aktiv",
    "access.status.inactive": "Inaktiv",
    "access.list.searchPlaceholder": "Zugriffsrichtlinien suchen...",
    // Avatar
    "avatar.image": "Bild",
    "avatar.name": "Name",
    "avatar.avatar": "Avatar",
    "avatar.gender": "Geschlecht",
    "avatar.age": "Alter",
    "avatar.model": "Modell",
    "avatar.onboarded": "Eingeführt",
    "avatar.processing": "Verarbeitung",
    "avatar.processing.done": "Fertig",
    "avatar.processing.is_processing": "Wird verarbeitet",
    "avatar.description": "Beschreibung",
    "avatar.listTitle": "Assistenten",
    "avatar.noAvatars": "Keine Assistenten gefunden",
    "avatar.addAvatar": "Assistent hinzufügen",
    "avatar.searchPlaceholder": "Assistent suchen...",
    "avatar.listView": "Listenansicht",
    "avatar.gridView": "Rasteransicht",
    "avatar.upload": "Avatar hochladen",
    "avatar.change": "Avatar ändern",
    "avatar.remove": "Avatar entfernen",
    // Avatar form page
    "avatar.form.knowledge.show": "Wissenseinträge anzeigen",
    "avatar.form.knowledge.label": "Wissensdatenbank-Einträge",
    "avatar.form.knowledge.search_placeholder": "Wissensdatenbank-Einträge suchen...",
    "avatar.form.knowledge.add": "Neues Wissen hinzufügen",
    "avatar.form.knowledge.fullscan": "Vollständiger Dokumentenscan",
    "avatar.form.title.edit": "Avatar bearbeiten",
    "avatar.form.title.add": "Avatar hinzufügen",
    "avatar.form.back": "Zurück",
    "avatar.form.name.label": "Name",
    "avatar.form.name.placeholder": "Avatar-Name",
    "avatar.form.gender.label": "Geschlecht",
    "avatar.form.gender.placeholder": "Geschlecht auswählen",
    "avatar.form.gender.none": "Keines",
    "avatar.form.gender.male": "Männlich",
    "avatar.form.gender.female": "Weiblich",
    "avatar.form.age.label": "Alter",
    "avatar.form.age.placeholder": "Avatar-Alter eingeben",
    "avatar.form.voice.label": "Stimme",
    "avatar.form.voice.placeholder": "Stimme auswählen",
    "avatar.form.voice.male": "Männliche Stimmen",
    "avatar.form.voice.female": "Weibliche Stimmen",
    "avatar.form.logo.label": "Avatar-Bild",
    "avatar.form.logo.placeholder": "Avatar-Bild senden",
    "avatar.form.instructionFile.label": "Anweisungsdatei",
    "avatar.form.instructionFile.placeholder": "Anweisungsdatei hochladen",
    "avatar.form.instructions.title": "Anweisungen",
    "avatar.form.instructions.description": "Verwalten Sie Anweisungseinträge, die das Verhalten des Avatars steuern. Jeder Eintrag erfordert eine Dateianlage und kann zusätzlich Notizen und einen Prompt enthalten.",
    "avatar.form.error.instruction_file_required": "Jeder Anweisungseintrag muss eine angehängte Datei haben.",
    "avatar.form.instructions.add": "Anweisung hinzufügen",
    "avatar.form.instructions.empty": "Noch keine Anweisungseinträge. Klicken Sie auf \"Anweisung hinzufügen\", um einen zu erstellen.",
    "avatar.form.instructions.untitled": "Unbenannte Schicht",
    "avatar.form.instructions.layer.label": "Schicht",
    "avatar.form.instructions.layer.placeholder": "Schichtname eingeben",
    "avatar.form.instructions.notes.label": "Notizen",
    "avatar.form.instructions.notes.placeholder": "Notizen zur Anweisung eingeben",
    "avatar.form.instructions.prompt.label": "Anweisungs-Prompt",
    "avatar.form.instructions.prompt.placeholder": "Anweisungs-Prompt eingeben",
    "avatar.form.instructions.file.label": "Anweisungsdatei",
    "avatar.form.instructions.isPublic.label": "Öffentlich (in Webhooks enthalten)",
    "avatar.form.instructions.file.placeholder": "Anweisungsdatei hochladen",
    "avatar.form.instructions.files.label": "Anweisungsdateien",
    "avatar.form.instructions.files.placeholder": "Anweisungsdateien hochladen",
    "avatar.form.instructions.versions.title": "Versionsverlauf",
    "avatar.form.instructions.versions.show": "Versionsverlauf anzeigen",
    "avatar.form.instructions.versions.hide": "Versionsverlauf ausblenden",
    "avatar.form.instructions.versions.empty": "Keine früheren Versionen verfügbar.",
    "avatar.form.instructions.versions.restore": "Wiederherstellen",
    "avatar.form.instructions.versions.restore_confirm": "Sind Sie sicher, dass Sie diese Version wiederherstellen möchten? Aktuelle Änderungen werden überschrieben.",
    "avatar.form.description.label": "Beschreibung",
    "avatar.form.description.placeholder": "Avatar-Beschreibung eingeben",
    "avatar.form.model.label": "KI-Modell",
    "avatar.form.model.placeholder": "KI-Modell auswählen",
    "avatar.form.knowledge.placeholder": "Wissenseinträge suchen...",
    "avatar.form.submit.update": "Avatar aktualisieren",
    "avatar.form.submit.create": "Avatar erstellen",
    "avatar.form.submit.saveAndReturn.update": "Avatar speichern & zur Liste zurückkehren",
    "avatar.form.submit.saveAndReturn.create": "Avatar erstellen & zur Liste zurückkehren",
    "avatar.form.tab.configuration": "Konfiguration",
    "avatar.form.tab.knowledge": "Wissensbasis",
    "avatar.form.tab.instructions": "Anweisungen",
    "avatar.form.tab.tools": "Werkzeuge",
    "avatar.form.tab.webhooks": "Webhooks",
    "avatar.form.tab.lexicon": "Lexikon",
    // Webhook-Konfiguration
    "avatar.form.webhooks.config.title": "Webhook-Konfiguration",
    "avatar.form.webhooks.config.description": "Autorisierungseinstellungen für alle Webhook-Endpunkte konfigurieren",
    "avatar.form.webhooks.config.authHeader.label": "Autorisierungs-Header",
    "avatar.form.webhooks.config.authHeader.placeholder": "z.B. Authorization",
    "avatar.form.webhooks.config.authKey.label": "Autorisierungs-Schlüssel",
    "avatar.form.webhooks.config.authKey.placeholder": "Bearer Token oder API-Schlüssel",
    // Webhook-Definitionen
    "avatar.form.webhooks.definitions.title": "Webhook-Definitionen",
    "avatar.form.webhooks.definitions.add": "Webhook hinzufügen",
    "avatar.form.webhooks.definitions.empty": "Keine Webhook-Definitionen konfiguriert. Klicken Sie auf \"Webhook hinzufügen\", um eine zu erstellen.",
    "avatar.form.webhooks.definitions.untitled": "Unbenannter Webhook",
    "avatar.form.webhooks.definitions.name.label": "Webhook-Name",
    "avatar.form.webhooks.definitions.name.placeholder": "Webhook-Name eingeben",
    "avatar.form.webhooks.definitions.address.label": "Webhook-URL",
    "avatar.form.webhooks.definitions.address.placeholder": "https://ihr-endpoint.com/webhook",
    "avatar.form.webhooks.definitions.eventType.label": "Ereignistyp",
    "avatar.form.webhooks.definitions.cronInterval.label": "Cron-Intervall",
    "avatar.form.webhooks.definitions.cronInterval.placeholder": "*/30 * * * *",
    "avatar.form.webhooks.definitions.cronInterval.help": "Cron-Ausdruck (z.B. */30 * * * * = alle 30 Minuten)",
    "avatar.form.webhooks.definitions.cronEnabled.label": "Cron aktivieren",
    "avatar.form.webhooks.definitions.active.label": "Aktiv",
    // Webhook-Ereignistypen
    "webhook.eventTypes.conversation_analysis": "Gesprächsanalyse",
    "webhook.eventTypes.avatar_updated": "Avatar aktualisiert",
    "webhook.eventTypes.avatar_deleted": "Avatar gelöscht",
    "webhook.eventTypes.avatar_test_complete": "Avatar-Test abgeschlossen",
    "webhook.eventTypes.knowledge_added": "Wissen hinzugefügt",
    "webhook.eventTypes.knowledge_removed": "Wissen entfernt",
    "webhook.eventTypes.knowledge_notify": "Wissen bearbeiten",
    // Wissen-Aktionen
    "knowledge.edit": "Wissen bearbeiten",
    // Webhook-Cron-Intervalle
    "webhook.cronIntervals.every_5_minutes": "Alle 5 Minuten",
    "webhook.cronIntervals.every_10_minutes": "Alle 10 Minuten",
    "webhook.cronIntervals.every_15_minutes": "Alle 15 Minuten",
    "webhook.cronIntervals.every_30_minutes": "Alle 30 Minuten",
    "webhook.cronIntervals.every_45_minutes": "Alle 45 Minuten",
    "webhook.cronIntervals.every_hour": "Jede Stunde",
    "webhook.cronIntervals.every_2_hours": "Alle 2 Stunden",
    "webhook.cronIntervals.every_6_hours": "Alle 6 Stunden",
    "webhook.cronIntervals.every_12_hours": "Alle 12 Stunden",
    "webhook.cronIntervals.daily": "Täglich (Mitternacht)",
    "webhook.cronIntervals.weekly": "Wöchentlich (Sonntag Mitternacht)",
    // Lexicon Konfiguration
    "avatar.form.lexicon.title": "Lexikon-Einträge",
    "avatar.form.lexicon.add": "Eintrag hinzufügen",
    "avatar.form.lexicon.empty": "Keine Lexikon-Einträge konfiguriert. Klicken Sie auf \"Eintrag hinzufügen\", um einen zu erstellen.",
    "avatar.form.lexicon.untitled": "Unbenannter Eintrag",
    "avatar.form.lexicon.hidden": "Versteckt",
    "avatar.form.lexicon.label.label": "Begriff",
    "avatar.form.lexicon.label.placeholder": "Begriff oder Wort eingeben",
    "avatar.form.lexicon.value.label": "Definition",
    "avatar.form.lexicon.value.placeholder": "Definition oder Erklärung eingeben",
    "avatar.form.lexicon.hidden.label": "Versteckt",
    "avatar.form.lexicon.hidden.help": "Wenn aktiviert, ist dieser Eintrag für Benutzer nicht sichtbar, wird aber vom Avatar zum Verstehen verwendet",
    // API-Werkzeuge
    "avatar.form.tab.apiTools": "API-Werkzeuge",
    "avatar.form.apiTools.title": "API-Werkzeuge",
    "avatar.form.apiTools.description": "Konfigurieren Sie externe API-Endpunkte, die die KI während Gesprächen aufrufen kann",
    "avatar.form.apiTools.enabled.label": "API-Werkzeuge aktivieren",
    "avatar.form.apiTools.enabled.help": "Erlauben Sie dem Avatar, Aufrufe an externe API-Endpunkte zu machen",
    "avatar.form.apiTools.list.title": "API-Endpunkte",
    "avatar.form.apiTools.add": "Endpunkt hinzufügen",
    "avatar.form.apiTools.empty": "Keine API-Endpunkte konfiguriert. Klicken Sie auf \"Endpunkt hinzufügen\", um einen zu erstellen.",
    "avatar.form.apiTools.untitled": "Unbenannter Endpunkt",
    "avatar.form.apiTools.name.label": "Name",
    "avatar.form.apiTools.name.placeholder": "Endpunktname eingeben",
    "avatar.form.apiTools.endpoint.label": "Endpunkt-URL",
    "avatar.form.apiTools.endpoint.placeholder": "https://api.example.com/endpoint",
    "avatar.form.apiTools.method.label": "Methode",
    "avatar.form.apiTools.description.label": "Beschreibung",
    "avatar.form.apiTools.description.placeholder": "Beschreiben Sie was dieser API-Endpunkt tut",
    "avatar.form.apiTools.description.help": "Eine Beschreibung hilft der KI zu verstehen wann und wie dieser Endpunkt verwendet werden soll",
    "avatar.form.apiTools.authEnabled.label": "Autorisierung aktivieren",
    "avatar.form.apiTools.authHeader.label": "Autorisierungs-Header",
    "avatar.form.apiTools.authHeader.placeholder": "z.B. Authorization",
    "avatar.form.apiTools.authKey.label": "Autorisierungsschlüssel",
    "avatar.form.apiTools.authKey.placeholder": "Bearer-Token oder API-Schlüssel",
    "avatar.form.apiTools.authKey.toggle": "Schlüssel anzeigen/verbergen",
    "avatar.form.apiTools.payloadFields.title": "Nutzlast-Felder",
    "avatar.form.apiTools.payloadFields.add": "Feld hinzufügen",
    "avatar.form.apiTools.payloadFields.description": "Definieren Sie die Felder, die die KI beim Aufruf dieses Endpunkts ausfüllt",
    "avatar.form.apiTools.payloadFields.empty": "Keine Nutzlast-Felder definiert. Klicken Sie auf \"Feld hinzufügen\", um eines zu erstellen.",
    "avatar.form.apiTools.payloadFields.name.label": "Feldname",
    "avatar.form.apiTools.payloadFields.name.placeholder": "z.B. query",
    "avatar.form.apiTools.payloadFields.desc.label": "Feldbeschreibung",
    "avatar.form.apiTools.payloadFields.desc.placeholder": "Beschreiben Sie wofür dieses Feld ist, damit die KI weiß wie es auszufüllen ist",
    "avatar.form.apiTools.payloadFields.type.label": "Typ",
    "avatar.form.apiTools.payloadFields.optional.label": "Optional",
    // Authorization webhook definitions
    "avatar.form.webhooks.definitions.authEnabled.label": "Autorisierung aktivieren",
    "avatar.form.webhooks.definitions.authHeader.label": "Autorisierungs-Header",
    "avatar.form.webhooks.definitions.authHeader.placeholder": "z.B. Authorization",
    "avatar.form.webhooks.definitions.authKey.label": "Autorisierungs-Schlüssel",
    "avatar.form.webhooks.definitions.authKey.placeholder": "Bearer Token oder API-Schlüssel",
    // Webhook-Payload-Beispiele
    "avatar.form.webhooks.payload.title": "Payload-Beispiel",
    "avatar.form.webhooks.payload.subtitle": "Beispiel JSON-Payload für diesen Webhook-Ereignistyp",
    "avatar.form.webhooks.payload.description": "Dies ist die Struktur der JSON-Daten, die an Ihren Webhook-Endpunkt gesendet werden.",
    "avatar.form.tools.title": "Verfügbare Werkzeuge",
    "avatar.form.tools.description": "Wählen Sie aus, welche Werkzeuge dieser Avatar in Gesprächen verwenden kann",
    "tools.imgGen.name": "Bildgenerierung",
    ...tools_aiFormAnalyzer_1.default,
    "tools.imgGen.description": "Bilder aus Textbeschreibungen generieren",
    "tools.convoTags.name": "Gesprächs-Tags",
    "tools.convoTags.description": "Relevante Tags zu Gesprächen basierend auf dem Kontext hinzufügen",
    "tools.galleryTags.name": "Galerie-Tags",
    "tools.galleryTags.description": "Galerieinhalte mit Tags verwalten und organisieren",
    "tools.detectContactData.name": "Kontaktdaten-Erkennung",
    "tools.detectContactData.description": "Erkennt und extrahiert automatisch Kontaktinformationen wie Telefonnummern, E-Mails, Adressen und Namen aus Benutzernachrichten",
    "tools.detectTasks.name": "Aufgaben-Erkennung",
    "tools.detectTasks.description": "Erkennt und extrahiert automatisch Aufgabeninformationen aus Benutzernachrichten",
    "tools.productCompare.name": "Produktvergleich",
    "tools.productCompare.description": "Vergleichen Sie Produkte von bestimmten E-Commerce-Domains und Websites",
    "tools.askForVoucher.name": "Gutschein-Anfrage",
    "tools.askForVoucher.description": "Erkennt Gutschein- oder Rabattanfragen aus Benutzernachrichten und löst clientseitige Gutschein-Aktionen aus",
    "tools.offerCreator.name": "Angebots-Ersteller",
    "tools.offerCreator.description": "Erkennt und vervollständigt Angebots-/Kostenvoranschlag-Informationen aus Benutzernachrichten, einschließlich Firmendetails, Besteuerungsarten und Geschäftstätigkeiten",
    "tools.quickOffer.name": "Schnellangebot",
    "tools.quickOffer.description": "Erfasst Felder des Schnellangebot-Formulars aus Benutzernachrichten basierend auf konfigurierten Feldern und Optionen",
    "tools.sendContactForm.name": "Kontaktformular",
    "tools.sendContactForm.description": "Erfasst Kontaktformulardaten (Name, E-Mail, Telefon, Nachricht) aus Benutzernachrichten und sendet eine Kontaktanfrage",
    "tools.apiTool.name": "API-Anfrage",
    "tools.apiTool.description": "Erfasst Daten aus dem Gespräch und sendet API-Anfragen an konfigurierte externe Endpunkte",
    "apiTool.requestSent": "Anfrage gesendet",
    "apiTool.requestFailed": "Anfrage fehlgeschlagen",
    "apiTool.collectingData": "Daten werden gesammelt...",
    "apiTool.response": "Antwort",
    "apiTool.noData": "Keine API-Anfragedaten vorhanden",
    "tools.productAPISearch.name": "Produktsuche & Kategorien",
    "tools.productAPISearch.description": "Suchen Sie nach Produkten und rufen Sie Produktkategorien über die SmartShop API-Integration ab",
    "tools.dynamicListings.name": "Dynamische Angebote",
    "tools.dynamicListings.description": "Zeigt ein kontextbezogenes Angebotspanel an, wenn eine bestimmte Gesprächsbedingung erfüllt ist",
    "tools.productCard": "Produktkarten",
    "tools.productCard.name": "Produktkarte",
    "tools.personalData.name": "Persönliche Datenerkennung",
    "tools.personalData.description": "Extrahieren und kategorisieren Sie persönliche Daten aus Benutzernachrichten wie Telefonnummern, E-Mails, Adressen, Namen usw.",
    "tools.rag.name": "Wissensdatenbank",
    "tools.rag.description": "Suche und Abruf relevanter Informationen aus Wissensdatenbank-Dokumenten",
    "avatar.form.error.load_failed": "Fehler beim Laden des Avatars",
    "avatar.form.error.model_required": "KI-Modell-Auswahl ist erforderlich",
    "avatar.form.error.action_failed": "Avatar-Aktion fehlgeschlagen",
    "avatar.form.error.general_error": "Allgemeiner Fehler beim",
    "avatar.form.action.updated": "aktualisiert",
    "avatar.form.action.created": "erstellt",
    "avatar.form.action.update": "aktualisieren",
    "avatar.form.action.create": "erstellen",
    "avatar.form.success.updated": "Avatar erfolgreich aktualisiert",
    "avatar.form.success.action_completed": "Avatar-Aktion erfolgreich abgeschlossen",
    "avatar.creator": "Ersteller",
    "avatar.voiceAgent": "Sprach-Agent",
    "avatar.common": "Gemeinsamer Avatar",
    "avatar.common.help": "Gemeinsame Avatare sind für alle Benutzer sichtbar, können aber nicht von Nicht-Super-Admins bearbeitet werden",
    "avatar.active": "Aktiv",
    "avatar.active.help": "Inaktive Avatare sind für normale Benutzer nicht sichtbar",
    "avatar.cantEditCommon": "Gemeinsame Avatare können nicht bearbeitet werden. Nur Super-Admins können gemeinsame Avatare bearbeiten.",
    "avatar.cantDeleteCommon": "Gemeinsame Avatare können nicht gelöscht werden. Nur Super-Admins können gemeinsame Avatare löschen.",
    // Avatar tooltips
    "avatar.tooltips.talk": "Gespräch mit diesem Avatar beginnen",
    "avatar.tooltips.preview": "Avatar-Details anzeigen",
    "avatar.tooltips.edit": "Avatar-Einstellungen bearbeiten",
    "avatar.tooltips.delete": "Diesen Avatar löschen",
    // Avatar knowledge management
    "avatar.knowledge.updated": "Avatar-Wissensbasis erfolgreich aktualisiert",
    "avatar.knowledge.load.error": "Fehler beim Laden der Avatar-Wissensbasis",
    "avatar.knowledge.update.error": "Fehler beim Aktualisieren der Avatar-Wissensbasis",
    // Avatar preview page
    "avatar.preview.title": "Avatar-Vorschau",
    "avatar.preview.edit": "Avatar bearbeiten",
    "avatar.preview.back": "Zurück zur Liste",
    "avatar.preview.not_provided": "Nicht angegeben",
    "avatar.preview.section.basic_info": "Grundinformationen",
    "avatar.preview.section.logo": "Avatar-Logo",
    "avatar.preview.section.description": "Beschreibung",
    "avatar.preview.section.ai_model": "KI-Modell-Konfiguration",
    // Style List Columns
    "style.name": "Name",
    "style.description": "Beschreibung",
    "style.prompt": "Prompt",
    "style.common": "Gemeinsamer Stil",
    "style.active": "Aktiv",
    "style.style": "Stil",
    // Style list page
    "style.listTitle": "Schreibstile",
    "style.addStyle": "Schreibstil hinzufügen",
    "style.searchPlaceholder": "Stile suchen...",
    // Style form page
    "style.form.title.edit": "Schreibstil bearbeiten",
    "style.form.title.add": "Schreibstil hinzufügen",
    "style.form.back": "Zurück",
    "style.form.name.label": "Name",
    "style.form.name.placeholder": "Stilname",
    "style.form.description.label": "Beschreibung",
    "style.form.description.placeholder": "Beschreiben Sie diesen Schreibstil",
    "style.form.prompt.label": "Stil-Prompt",
    "style.form.prompt.placeholder": "Geben Sie den KI-Prompt ein, der diesen Schreibstil definiert...",
    "style.form.common.label": "Gemeinsamer Stil",
    "style.form.common.description": "Gemeinsame Stile sind für alle Benutzer verfügbar, können aber nur von Super-Admins bearbeitet werden",
    "style.form.active.label": "Aktiv",
    "style.updated": "aktualisiert",
    "style.created": "erstellt",
    "style.update": "aktualisieren",
    "style.create": "erstellen",
    "avatar.preview.section.knowledge": "Wissensbasis",
    "avatar.preview.section.settings": "Avatar-Einstellungen",
    "avatar.preview.section.validation": "Konfigurationsstatus",
    "avatar.preview.logo.not_uploaded": "Kein Logo hochgeladen",
    "avatar.preview.provider": "Anbieter",
    "avatar.preview.cost": "Kosten",
    "avatar.preview.model.not_selected": "Kein KI-Modell ausgewählt - Dies ist erforderlich!",
    "avatar.preview.knowledge.entries_selected": "Wissenseinträge ausgewählt",
    "avatar.preview.knowledge.none_selected": "Keine Wissensbasis-Einträge ausgewählt",
    "avatar.preview.validation.status": "Konfigurationsvalidierung",
    "avatar.preview.validation.complete": "Alle erforderlichen Felder sind ausgefüllt",
    "avatar.preview.validation.incomplete": "Einige erforderliche Felder fehlen",
    "avatar.preview.no_data": "Keine Avatar-Daten verfügbar",
    "avatar.preview.error.load_failed": "Fehler beim Laden des Avatars für die Vorschau",
    "avatar.preview.voice.not_selected": "Keine Stimme ausgewählt",
    "avatar.preview.unnamed": "Unbenannter Avatar",
    "avatar.preview.required": "Erforderlich",
    "avatar.preview.gender.not_selected": "Kein Geschlecht ausgewählt",
    "avatar.preview.section.conversations": "Konversationen",
    "avatar.preview.conversations.empty": "Noch keine Konversationen mit diesem Avatar",
    "avatar.preview.conversations.untitled": "Unbenannte Konversation",
    // Preispaket List Columns
    "accountGrade.name": "Name",
    "accountGrade.description": "Beschreibung",
    "accountGrade.price": "Monatlicher Preis",
    "accountGrade.yearlyPrice": "Jährlicher Preis",
    "accountGrade.creditsPerMonth": "Credits pro Monat",
    "accountGrade.advancedPrompts": "Erweiterte Prompts",
    "accountGrade.promptAssist": "Prompt-Assistent",
    "accountGrade.maxAvatars": "Max. Avatare",
    "accountGrade.maxUsers": "Max. Benutzer",
    "accountGrade.maxProjectsCount": "Max. Projekte",
    "accountGrade.maxKnowledgeEntries": "Max. Wissen",
    "accountGrade.antiHallucination": "Anti-Halluzination",
    "accountGrade.advancedReports": "Erweiterte Berichte",
    "accountGrade.chatThreadSharing": "Chat-Thread-Sharing",
    "accountGrade.customBranding": "Custom Branding",
    "accountGrade.widgets": "Widgets",
    "accountGrade.customAiModels": "Custom AI-Modelle",
    "accountGrade.voiceAgent": "Sprach-Agent",
    "accountGrade.writingStyles": "Schreibstile",
    "accountGrade.active": "Aktiv",
    "accountGrade.order": "Reihenfolge",
    // Preispaket list page
    "accountGrade.listTitle": "Preispakete",
    "accountGrade.list.title": "Preispakete",
    "accountGrade.noAccountGrades": "Keine Preispakete gefunden",
    "accountGrade.noResults": "Keine Preispakete gefunden",
    "accountGrade.addAccountGrade": "Preispaket hinzufügen",
    "accountGrade.add": "Preispaket hinzufügen",
    "accountGrade.createTitle": "Preispaket erstellen",
    "accountGrade.searchPlaceholder": "Preispaket suchen...",
    // Preispaket form page
    "accountGrade.form.title.edit": "Preispaket bearbeiten",
    "accountGrade.form.title.add": "Preispaket hinzufügen",
    "accountGrade.form.back": "Zurück",
    "accountGrade.form.name.label": "Name",
    "accountGrade.form.name.placeholder": "Name des Preispaketes",
    "accountGrade.form.description.label": "Beschreibung",
    "accountGrade.form.description.placeholder": "Beschreibung des Preispaketes",
    "accountGrade.form.advancedPrompts.label": "Erweiterte Prompts",
    "accountGrade.form.advancedPrompts.description": "Benutzern Zugang zu erweiterten Prompt-Funktionen gewähren",
    "accountGrade.form.promptAssist.label": "Prompt-Assistent",
    "accountGrade.form.promptAssist.description": "Hilfe bei der Prompt-Erstellung bereitstellen",
    "accountGrade.form.maxAvatars.label": "Max. Avatare",
    "accountGrade.form.maxAvatars.placeholder": "Maximale Anzahl von Avataren (leer lassen für unbegrenzt)",
    "accountGrade.form.maxUsers.label": "Max. Benutzer",
    "accountGrade.form.maxUsers.placeholder": "Maximale Anzahl von Benutzern (leer lassen für unbegrenzt)",
    "accountGrade.form.maxProjectsCount.label": "Max. Projekte",
    "accountGrade.form.maxProjectsCount.placeholder": "Maximale Anzahl von Projekten (leer lassen für unbegrenzt)",
    "accountGrade.form.maxKnowledgeEntries.label": "Max. Wissenseinträge",
    "accountGrade.form.maxKnowledgeEntries.placeholder": "Maximale Anzahl von Wissenseinträgen (leer lassen für unbegrenzt)",
    "accountGrade.form.antiHallucination.label": "Anti-Halluzination",
    "accountGrade.form.antiHallucination.description": "Anti-Halluzinations-Funktionen aktivieren",
    "accountGrade.form.advancedReports.label": "Erweiterte Berichte",
    "accountGrade.form.advancedReports.description": "Zugang zu erweiterten Berichtsfunktionen",
    "accountGrade.form.chatThreadSharing.label": "Chat-Thread-Sharing",
    "accountGrade.form.chatThreadSharing.description": "Teilen von Chat-Threads erlauben",
    "accountGrade.form.customBranding.label": "Custom Branding",
    "accountGrade.form.customBranding.description": "Custom Branding-Optionen aktivieren",
    "accountGrade.form.widgets.label": "Widgets",
    "accountGrade.form.widgets.description": "Zugang zur Widget-Funktionalität",
    "accountGrade.form.customAiModels.label": "Custom AI-Modelle",
    "accountGrade.form.customAiModels.description": "Custom AI-Modell-Konfigurationen erlauben",
    "accountGrade.form.voiceAgent.label": "Sprach-Agent",
    "accountGrade.form.voiceAgent.description": "Sprach-Agent-Funktionalität aktivieren",
    "accountGrade.form.writingStyles.label": "Schreibstile",
    "accountGrade.form.writingStyles.description": "Zugang zu Schreibstil-Funktionen",
    "accountGrade.form.save": "Preispaket speichern",
    "accountGrade.form.saving": "Speichern...",
    "accountGrade.form.unlimited": "Unbegrenzt",
    "accountGrade.form.price.label": "Monatlicher Preis",
    "accountGrade.form.price.placeholder": "Monatlicher Preis (in USD)",
    "accountGrade.form.price.monthly.help": "Monatlicher Abonnementpreis in USD",
    "accountGrade.form.yearlyPrice.placeholder": "Jährlicher Preis (in USD)",
    "accountGrade.form.yearlyPrice.help": "Jährlicher Abonnementpreis in USD (normalerweise mit Rabatt)",
    "accountGrade.form.creditsPerMonth.placeholder": "Anzahl der Credits pro Monat",
    "accountGrade.form.creditsPerMonth.help": "Credits werden automatisch jeden Monat zu Benutzerkonten hinzugefügt",
    "accountGrade.form.active.label": "Aktiv",
    "accountGrade.form.active.description": "Dieses Preispaket verfügbar machen",
    "accountGrade.form.order.label": "Reihenfolge",
    "accountGrade.form.order.placeholder": "Anzeigereihenfolge (optional)",
    // Preispaket sections
    "accountGrade.previewTitle": "Kontograd-Vorschau",
    "accountGrade.basicInfo": "Grundinformationen",
    "accountGrade.features": "Funktionen",
    "accountGrade.status": "Status",
    "accountGrade.limits": "Limits",
    "accountGrade.unlimited": "Unbegrenzt",
    // Account limits and restrictions
    "limits.noAccountGrade": "Kein Kontoplan gefunden. Bitte wenden Sie sich an den Support.",
    "limits.avatar.exceeded": "Avatar-Limit erreicht. Upgraden Sie Ihren Plan, um weitere Avatare zu erstellen.",
    "limits.avatar.limitReached": "Avatar-Limit: {limit} (upgraden für mehr)",
    "limits.user.exceeded": "Benutzer-Limit erreicht. Upgraden Sie Ihren Plan, um weitere Benutzer hinzuzufügen.",
    "limits.user.limitReached": "Benutzer-Limit: {limit} (upgraden für mehr)",
    "limits.project.exceeded": "Projekt-Limit erreicht. Upgraden Sie Ihren Plan, um weitere Projekte zu erstellen.",
    "limits.project.limitReached": "Projekt-Limit: {limit} (upgraden für mehr)",
    "limits.knowledge.exceeded": "Wissens-Einträge-Limit erreicht. Upgraden Sie Ihren Plan, um weitere Einträge hinzuzufügen.",
    "limits.knowledge.limitReached": "Wissens-Limit: {limit} (upgraden für mehr)",
    "limits.bulk.exceeded": "Kann {itemsToAdd} Dateien nicht hochladen. Sie haben {remainingSlots} Plätze von {limit} maximal erlaubten Einträgen übrig.",
    "limits.featureDisabled": "Diese Funktion ist für Ihren Kontoplan deaktiviert.",
    "limits.customModel.exceeded": "Custom-KI-Modell-Limit erreicht. Upgraden Sie Ihren Plan, um weitere Modelle zu trainieren.",
    "limits.customModel.limitReached": "Custom-Modell-Limit: {limit} (upgraden für mehr)",
    "limits.writingStyles.disabled": "Die Schreibstil-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.advanced-prompts.disabled": "Die erweiterten Prompts-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.prompt-assist.disabled": "Die Prompt-Assistent-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.anti-hallucination.disabled": "Die Anti-Halluzination-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.advanced-reports.disabled": "Die erweiterten Berichte-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.chat-thread-sharing.disabled": "Die Chat-Thread-Freigabe-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.custom-branding.disabled": "Die Custom-Branding-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.widgets.disabled": "Die Widgets-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.voice-agent.disabled": "Die Sprach-Agent-Funktion ist in Ihrem aktuellen Plan nicht verfügbar.",
    "limits.upgrade.message": "Upgraden Sie Ihren Kontoplan, um auf diese Funktion zuzugreifen.",
    "limits.upgrade.link": "Jetzt upgraden",
    // Voice chat errors
    "voice-chat.error.noModelOrAvatar": "Bitte wählen Sie ein Modell oder Avatar aus, um eine Sprachunterhaltung zu starten.",
    "voice_chat.session_timeout": "Sprachunterhaltungssession aufgrund von Inaktivität abgelaufen. Bitte starten Sie eine neue Unterhaltung.",
    // Email translations
    "email.pass_reset.subject": "Passwort zurücksetzen",
    "email.pass_reset.title": "Passwort zurücksetzen",
    "email.pass_reset.text": "Sie haben angefordert, Ihr Passwort zurückzusetzen. Klicken Sie auf die Schaltfläche unten, um ein neues Passwort festzulegen.",
    "email.pass_reset.button": "Passwort zurücksetzen",
    "email.activation.subject": "Aktivieren Sie Ihr Konto",
    "email.activation.title": "Willkommen bei IntHub!",
    "email.activation.text": "Vielen Dank für Ihre Registrierung bei IntHub. Um Ihre Registrierung abzuschließen und Ihr Konto zu aktivieren, klicken Sie bitte auf die Schaltfläche unten.",
    "email.activation.button": "Konto aktivieren",
    // Account upgrade emails
    "email.upgrade.subject": "Konto erfolgreich aufgewertet",
    "email.upgrade.title": "Ihr Konto wurde aufgewertet!",
    "email.upgrade.text": "Großartige Neuigkeiten! Ihr Konto wurde erfolgreich aufgewertet und Sie haben jetzt Zugang zu erweiterten Funktionen.",
    "email.upgrade.new_plan": "Neuer Plan",
    "email.upgrade.benefits": "Sie können nun alle Vorteile Ihres neuen Abonnement-Plans genießen.",
    "email.upgrade.dashboard_button": "Zum Dashboard",
    "email.upgrade.footer": "Vielen Dank, dass Sie sich für IntHub entschieden haben!",
    // Payment success emails
    "email.payment.success.subject": "Zahlung erfolgreich - Abonnement bestätigt",
    "email.payment.success.title": "Zahlung erfolgreich verarbeitet!",
    "email.payment.success.text": "Vielen Dank für Ihre Zahlung. Ihr Abonnement wurde bestätigt und ist jetzt aktiv.",
    "email.payment.success.confirmation": "Sie erhalten in Kürze eine Quittung für diese Zahlung.",
    "email.payment.success.footer": "Bei Fragen wenden Sie sich bitte an unser Support-Team.",
    // Payment failed emails
    "email.payment.failed.subject": "Zahlung fehlgeschlagen - Aktion erforderlich",
    "email.payment.failed.title": "Zahlungsverarbeitung fehlgeschlagen",
    "email.payment.failed.text": "Wir konnten Ihre Zahlung für Ihr Abonnement nicht verarbeiten. Bitte aktualisieren Sie Ihre Zahlungsmethode, um unsere Dienste weiterhin nutzen zu können.",
    "email.payment.failed.retry_text": "Um eine Unterbrechung des Services zu vermeiden, versuchen Sie bitte so bald wie möglich eine erneute Zahlung.",
    "email.payment.failed.retry_button": "Zahlung wiederholen",
    "email.payment.failed.support_button": "Support kontaktieren",
    "email.payment.failed.footer": "Wenn weiterhin Probleme auftreten, wenden Sie sich bitte an unser Support-Team.",
    // Common payment fields
    "email.payment.plan": "Abonnement-Plan",
    "email.payment.amount": "Betrag",
    "email.payment.next_billing": "Nächstes Abrechnungsdatum",
    "email.payment.failure_reason": "Grund für Fehlschlag",
    "email.payment.dashboard_button": "Dashboard anzeigen",
    "email.payment.download_invoice": "Rechnung herunterladen",
    // Registration completion
    "register.complete.hero.title": "Willkommen bei IntHub!",
    "register.complete.hero.description": "Ihr Konto wurde erfolgreich erstellt. Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu aktivieren.",
    "register.complete.title": "Registrierung erfolgreich!",
    "register.complete.description": "Vielen Dank, dass Sie IntHub beigetreten sind. Wir haben eine Aktivierungs-E-Mail an Ihre Adresse gesendet.",
    "register.complete.email.check": "Bitte überprüfen Sie Ihren E-Mail-Posteingang und klicken Sie auf den Aktivierungslink, um Ihre Registrierung abzuschließen.",
    "register.complete.login.button": "Zur Anmeldung",
    "register.complete.home.button": "Zurück zur Startseite",
    "register.complete.help.text": "Benötigen Sie Hilfe?",
    "register.complete.help.link": "Support kontaktieren",
    // Password Reset Page
    "password.reset.hero.title": "Passwort vergessen?",
    "password.reset.hero.description": "Keine Sorge, das passiert jedem. Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
    "password.reset.hero.login_link_text": "Passwort wieder eingefallen?",
    "password.reset.hero.login_link": "Hier anmelden",
    "password.reset.page.title": "Passwort zurücksetzen",
    "password.reset.form.title": "Passwort zurücksetzen",
    "password.reset.email.label": "E-Mail-Adresse",
    "password.reset.email.placeholder": "E-Mail-Adresse eingeben",
    "password.reset.submit": "Reset-Link senden",
    "password.reset.backToLogin": "Zurück zur Anmeldung",
    "password.reset.success.title": "E-Mail gesendet!",
    "password.reset.success.description": "Überprüfen Sie Ihre E-Mails für Anweisungen zum Zurücksetzen Ihres Passworts.",
    // Password Reset Confirm Page
    "password.reset.confirm.hero.title": "Neues Passwort festlegen",
    "password.reset.confirm.hero.description": "Erstellen Sie ein starkes Passwort, das Sie sich merken können. Ihr neues Passwort sollte sich von Ihrem vorherigen unterscheiden.",
    "password.reset.confirm.hero.login_link_text": "Passwort wieder eingefallen?",
    "password.reset.confirm.hero.login_link": "Hier anmelden",
    "password.reset.confirm.page.title": "Neues Passwort festlegen",
    "password.reset.confirm.form.title": "Neues Passwort erstellen",
    "password.reset.confirm.password.label": "Neues Passwort",
    "password.reset.confirm.password.placeholder": "Neues Passwort eingeben",
    "password.reset.confirm.confirmPassword.label": "Passwort bestätigen",
    "password.reset.confirm.confirmPassword.placeholder": "Neues Passwort bestätigen",
    "password.reset.confirm.submit": "Passwort zurücksetzen",
    "password.reset.confirm.success.title": "Passwort zurückgesetzt!",
    "password.reset.confirm.success.description": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    "accountGrade.form.submit.create": "Preispaket erstellen",
    "accountGrade.form.submit.update": "Preispaket aktualisieren",
    // Preispaket preview page
    "accountGrade.preview.title": "Preispaket-Details",
    "accountGrade.preview.back": "Zurück zu Preispaketen",
    "accountGrade.preview.edit": "Preispaket bearbeiten",
    "accountGrade.preview.delete": "Preispaket löschen",
    "accountGrade.preview.enabled": "Aktiviert",
    "accountGrade.preview.disabled": "Deaktiviert",
    "accountGrade.preview.no_data": "Keine Preispaket-Daten verfügbar",
    "accountGrade.preview.error.load_failed": "Fehler beim Laden des Preispaketes für die Vorschau",
    "accountGrade.preview.unnamed": "Unbenanntes Preispaket",
    "accountGrade.preview.no_description": "Keine Beschreibung angegeben",
    "accountGrade.preview.price": "Monatlicher Preis",
    "accountGrade.preview.free": "Kostenlos",
    "accountGrade.preview.cents": "Cent",
    "accountGrade.preview.active_status": "Status",
    "accountGrade.preview.order": "Anzeigereihenfolge",
    // Account upgrade page
    "account.upgrade.errors.loadGrades": "Fehler beim Laden der Preispakete",
    "account.upgrade.loadingGrades": "Preispakete werden geladen...",
    // Preispaket features
    "account.grades.features.advancedPrompts": "Erweiterte Prompts",
    "account.grades.features.promptAssist": "Prompt-Assistent",
    "account.grades.features.antiHallucination": "Anti-Halluzination",
    "account.grades.features.advancedReports": "Erweiterte Berichte",
    "account.grades.features.chatThreadSharing": "Chat-Thread-Sharing",
    "account.grades.features.customBranding": "Custom Branding",
    "account.grades.features.widgets": "Widgets",
    "account.grades.features.customAiModels": "Custom AI-Modelle",
    "account.grades.features.voiceAgent": "Sprach-Agent",
    "account.grades.features.writingStyles": "Schreibstile",
    "account.grades.features.maxAvatars": "Avatare",
    "account.grades.features.maxUsers": "Benutzer",
    "account.grades.features.maxProjects": "Projekte",
    "account.grades.features.maxKnowledge": "Wissenseinträge",
    // Conversation/Chat
    "conversation.start": "Konversation starten",
    "conversation.auto.turn.detection": "Automatische Redezeitenerkennung",
    "conversation.auto.turn.detection.help": "Aufnahme automatisch beenden wenn Stille erkannt wird",
    "conversation.start.recording": "Aufnahme starten",
    "conversation.stop.recording": "Aufnahme stoppen",
    "conversation.recording.active": "Aufnahme aktiv",
    "conversation.recording.inactive": "Aufnahme inaktiv",
    "conversation.send": "Senden",
    "conversation.message": "Nachricht",
    "conversation.demo": "Sprach-Agent",
    "conversation.agent": "Agent",
    "conversation.connected": "Verbunden",
    "conversation.disconnected": "Getrennt",
    "conversation.connecting": "Verbindung wird hergestellt...",
    "conversation.voice": "Stimme",
    "conversation.you": "Sie",
    "conversation.type.message": "Nachricht eingeben...",
    "conversation.agent.speaking": "Agent spricht",
    "conversation.agent.thinking": "Agent denkt nach...",
    "conversation_agent.first_word": "Hallo, wie kann ich Ihnen heute helfen?",
    "conversation.volume": "Lautstärke",
    "conversation.debug": "Debug-Informationen",
    "conversation.session.id": "Sitzungs-ID",
    "conversation.avatar.id": "Avatar-ID",
    "conversation.voice.id": "Stimm-ID",
    "conversation.language": "Sprache",
    "conversation.messages": "Nachrichten",
    "conversation.clear.messages": "Nachrichten löschen",
    "conversation.started": "Konversation erfolgreich gestartet!",
    // Share conversation
    "share.conversation.loading": "Konversation wird geladen...",
    "share.conversation.noIdProvided": "Keine Konversations-ID angegeben",
    "share.conversation.failedToLoad": "Konversation konnte nicht geladen werden",
    "share.conversation.untitled": "Unbenannte Konversation",
    "share.conversation.linkCopied": "Link in die Zwischenablage kopiert",
    "share.conversation.linkCopyFailed": "Link konnte nicht kopiert werden",
    "share.conversation.copyLink": "Link kopieren",
    "share.conversation.goToChat": "Zum Chat gehen",
    "share.conversation.you": "Sie",
    "share.conversation.assistant": "Assistent",
    "share.conversation.reasoning": "Begründung",
    "share.conversation.thoughts": "Gedanken",
    "share.conversation.sources": "Quellen",
    "share.conversation.toolsUsed": "Verwendete Tools",
    "share.conversation.noMessages": "Keine Nachrichten gefunden",
    "share.conversation.noMessagesDescription": "Diese Konversation scheint leer zu sein oder die Nachrichten konnten nicht geladen werden.",
    "share.conversation.footerNote": "Dies ist eine geteilte Konversation. Sie können Ihren eigenen Chat starten, um mit der KI zu interagieren.",
    "share.conversation.startNewChat": "Neuen Chat starten",
    "share.conversation.unknownModel": "Unbekanntes Modell",
    "conversation.ended": "Konversation beendet.",
    "conversation.error": "Ein Fehler ist während der Konversation aufgetreten.",
    "conversation.end": "Konversation beenden",
    "recording.start": "Aufnahme starten",
    "recording.stop": "Aufnahme stoppen",
    "recording.start.failed": "Aufnahme konnte nicht gestartet werden",
    "recording.process.failed": "Aufnahme konnte nicht verarbeitet werden",
    "conversation.start.failed": "Konversation konnte nicht gestartet werden",
    "conversation.end.failed": "Konversation konnte nicht beendet werden",
    "message.send.failed": "Nachricht konnte nicht gesendet werden",
    "message.used_tools": "Verwendete Tools",
    "microphone.access.denied": "Mikrofon-Zugriff verweigert. Bitte erlauben Sie den Mikrofon-Zugriff für Sprachfunktionen.",
    "conversation.agent.demo": "Sprach-Agent Demo",
    "conversation.agent.demo.description": "Interaktive Sprachkonversation mit KI-Agenten unter Verwendung fortschrittlicher Spracherkennung und -synthese",
    "conversation.interruption.hint": "Sie können den Agenten durch Sprechen unterbrechen",
    "conversation.interruption.active": "Agent wird unterbrochen...",
    // Settings
    "settings.access": "Zugriffsverwaltung",
    "settings.profile": "Profil",
    "settings.security": "Sicherheit",
    // Table & Pagination
    "table.noData": "Keine Daten verfügbar",
    "table.rowsPerPage": "Zeilen pro Seite",
    "table.of": "von",
    "table.page": "Seite",
    // Table columns and controls
    "table.controls.export": "Exportieren",
    "table.controls.columns": "Spalten",
    // CRUD operations
    "crud.create": "Erstellen",
    "crud.edit": "Bearbeiten",
    "crud.delete": "Löschen",
    "crud.preview": "Vorschau",
    "crud.saving": "Speichern...",
    "crud.filtering": "Filtern",
    "crud.searchPlaceholder": "Suchen...",
    "crud.noCompanies": "Keine Firmen gefunden",
    "crud.noEntries": "Keine Einträge gefunden",
    "crud.failedToLoad": "Daten konnten nicht geladen werden",
    "crud.confirmDelete": "Sind Sie sicher, dass Sie löschen möchten",
    "crud.deletedSuccessfully": "Erfolgreich gelöscht",
    "crud.failedToDelete": "Löschen fehlgeschlagen",
    "crud.cantEditItem": "Dieses Element kann nicht bearbeitet werden",
    "crud.cantDeleteItem": "Dieses Element kann nicht gelöscht werden",
    // Form operations
    "form.back": "Zurück",
    // Common status terms
    "common.yes": "Ja",
    "common.no": "Nein",
    "common.active": "Aktiv",
    "common.inactive": "Inaktiv",
    "common.common": "Gemeinsam",
    "common.free": "Kostenlos",
    "common.unlimited": "Unbegrenzt",
    "common.ordering": "Reihenfolge",
    "common.createdAt": "Erstellt Am",
    // Payment
    "payment.gateway": "Payment Gateway",
    "payment.provider": "Zahlungsanbieter",
    "payment.amount": "Betrag",
    "payment.description": "Beschreibung",
    "payment.sessionId": "Session-ID",
    "payment.id": "Zahlungs-ID",
    "payment.status": "Zahlungsstatus",
    "payment.currentStatus": "Aktueller Status",
    "payment.initiate": "Zahlung starten",
    "payment.testConnection": "Verbindung testen",
    "payment.refreshStatus": "Status aktualisieren",
    "payment.reset": "Zahlung zurücksetzen",
    "payment.defaultDescription": "Zahlungstransaktion",
    "payment.initialized": "Zahlung erfolgreich initialisiert",
    "payment.initializationFailed": "Zahlungsinitialisierung fehlgeschlagen",
    "payment.successful": "Zahlung erfolgreich abgeschlossen",
    "payment.pending": "Zahlung ausstehend",
    "payment.rejected": "Zahlung abgelehnt",
    "payment.error": "Zahlungsfehler aufgetreten",
    "payment.connectionSuccessful": "Verbindung zum Zahlungsanbieter erfolgreich",
    "payment.connectionFailed": "Verbindung zum Zahlungsanbieter fehlgeschlagen",
    "payment.statusCheckFailed": "Statusprüfung der Zahlung fehlgeschlagen",
    "payment.noPaymentId": "Keine Zahlungs-ID verfügbar",
    "payment.processing": "Verarbeitung...",
    "payment.confirmationFailed": "Zahlungsbestätigung fehlgeschlagen",
    "payment.validation.providerRequired": "Zahlungsanbieter ist erforderlich",
    "payment.validation.amountRequired": "Gültiger Betrag ist erforderlich",
    "payment.validation.currencyRequired": "Währung ist erforderlich",
    "payment.status.pending": "Ausstehend",
    "payment.status.success": "Erfolgreich",
    "payment.status.rejected": "Abgelehnt",
    "payment.status.error": "Fehler",
    "payment.status.unknown": "Unbekannt",
    "payment.stripe.info": "Bitte vervollständigen Sie die Zahlung mit Stripe Elements unten.",
    "payment.stripe.clientSecret": "Client Secret",
    "payment.stripe.noClientSecret": "Kein Stripe Client Secret verfügbar",
    "payment.unsupportedProvider": "Nicht unterstützter Zahlungsanbieter",
    "payment.selectProvider": "Zahlungsanbieter auswählen",
    "payment.operationName": "Zahlungsvorgang",
    "payment.provider.stripe.description": "Bezahlen Sie mit Kredit-, Debitkarten und digitalen Geldbörsen über Stripe",
    "payment.confirmed.title": "Zahlung erfolgreich!",
    "payment.confirmed.message": "Vielen Dank für Ihre Zahlung. Ihre Transaktion wurde erfolgreich abgeschlossen.",
    "payment.confirmed.details": "Zahlungsdetails",
    "payment.confirmed.date": "Zahlungsdatum",
    "payment.confirmed.paymentIntent": "Zahlungsabsichts-ID",
    "payment.confirmed.fetchError": "Zahlungsdetails können nicht abgerufen werden",
    "payment.confirmed.unknownProvider": "Unbekannter Anbieter",
    "payment.confirmed.accountUpgraded": "Konto erfolgreich aufgewertet",
    "payment.confirmed.accountUpgradedMessage": "Ihr Konto wurde aufgewertet und neue Funktionen sind jetzt verfügbar.",
    "payment.confirmed.nextSteps": "Wie geht es weiter?",
    "payment.confirmed.nextStepsMessage": "Sie können jetzt Ihre erweiterten Funktionen nutzen. Entdecken Sie AI-Chat, erstellen Sie Avatare und verwalten Sie Ihre Wissensdatenbank.",
    "payment.confirmed.startChatting": "Chat starten",
    "payment.confirmed.viewAccount": "Konto anzeigen",
    "payment.confirmed.backHome": "Zurück zur Startseite",
    "payment.confirmed.receiptInfo": "Eine Quittung wurde an Ihre E-Mail-Adresse gesendet. Sie können sie auch in Ihren Kontoeinstellungen herunterladen.",
    "route.payment.confirmed": "Zahlung Bestätigt",
    // Payment List & Preview
    "payment.user": "Benutzer",
    "payment.email": "E-Mail",
    "payment.targetGrade": "Zielgrad",
    "payment.paidAt": "Bezahlt am",
    "payment.failureReason": "Grund des Fehlers",
    "payment.details": "Zahlungsdetails",
    "payment.timeline": "Zeitachse",
    "payment.created": "Erstellt",
    "payment.updated": "Aktualisiert",
    "payment.technicalDetails": "Technische Details",
    "payment.stripePaymentIntentId": "Stripe Zahlungsabsicht-ID",
    "payment.stripeCustomerId": "Stripe Kunden-ID",
    "payment.orderId": "Bestell-ID",
    "payment.metadata": "Metadaten",
    "payment.search.placeholder": "Zahlungen nach Sitzungs-ID, Beschreibung, E-Mail suchen...",
    "payment.preview.errors.noId": "Keine Zahlungs-ID angegeben",
    "payment.preview.errors.loadFailed": "Laden der Zahlungsdetails fehlgeschlagen",
    "payment.preview.refreshed": "Zahlungsdetails aktualisiert",
    "route.payment.list": "Zahlungen",
    "route.payment.preview": "Zahlungsdetails",
    // Notifications
    "notification.saved": "Erfolgreich gespeichert!",
    "notification.deleted": "Erfolgreich gelöscht!",
    "notification.updated": "Erfolgreich aktualisiert!",
    "notification.error": "Ein Fehler ist aufgetreten.",
    // Register page
    "register.nameLabel": "Name",
    "register.lastNameLabel": "Nachname",
    "register.usernameLabel": "Benutzername",
    "register.emailLabel": "E-Mail",
    "register.passwordLabel": "Passwort",
    "register.repeatPasswordLabel": "Passwort wiederholen",
    "register.submit": "Registrieren",
    // Routes
    "route.home": "Startseite",
    "route.login": "Anmelden",
    "route.register": "Registrieren",
    "route.profile": "Profil",
    "route.team": "Team",
    "route.settings": "Einstellungen",
    "route.management": "Verwaltung",
    "route.avatar": "Avatar",
    "route.company": "Firma",
    "route.user": "Benutzer",
    "route.conversation": "Konversation",
    "route.dashboard": "Dashboard",
    "route.companyManagement": "Firmenverwaltung",
    "route.companyManagement.list": "Firmenverwaltung",
    "route.assistants": "Assistenten",
    // Settings routes
    "route.settings.general": "Allgemein",
    "route.settings.styles": "Stile",
    "route.settings.access": "Zugriff",
    "route.settings.accessEdit": "Zugriff bearbeiten",
    "route.settings.accessAdd": "Zugriff hinzufügen",
    // Style routes
    "route.styles": "Schreibstile",
    "route.style.list": "Schreibstile",
    "route.style.create": "Schreibstil hinzufügen",
    "route.style.edit": "Schreibstil bearbeiten",
    "route.style.preview": "Schreibstil-Vorschau",
    // Reports routes
    "route.reports.cost": "Kostenberichte",
    "route.reports.shared": "Geteilte Gespräche",
    // Management routes
    "route.company.list": "Firmen",
    "route.company.create": "Firma hinzufügen",
    "route.company.edit": "Firma bearbeiten",
    "route.user.list": "Benutzer",
    "route.user.create": "Benutzer hinzufügen",
    "route.user.edit": "Benutzer bearbeiten",
    "route.accountGrade.list": "Preispakete",
    "route.accountGrade.create": "Preispaket erstellen",
    "route.accountGrade.edit": "Preispaket bearbeiten",
    "route.accountGrade.preview": "Preispaket Vorschau",
    "route.branch.list": "Branchen",
    "route.branch.create": "Branche hinzufügen",
    "route.branch.edit": "Branche bearbeiten",
    "route.profession.list": "Berufe",
    "route.profession.create": "Beruf hinzufügen",
    "route.profession.edit": "Beruf bearbeiten",
    // Avatar routes
    "route.avatar.list": "Avatare",
    "route.avatar.create": "Avatar hinzufügen",
    "route.avatar.edit": "Avatar bearbeiten",
    "route.avatar.preview": "Avatar-Vorschau",
    "route.conversation.list": "Konversationen",
    "route.conversations": "Konversationen",
    "route.conversationList": "Konversationen",
    "route.conversationPreview": "Konversation Vorschau",
    "route.botTest.list": "Bot-Tests",
    "route.tutorial.list": "Tutorials",
    "tutorial.create.title": "Tutorial erstellen",
    "tutorial.edit.title": "Tutorial bearbeiten",
    "tutorial.preview.title": "Tutorial Vorschau",
    "tutorial.delete.confirm": "Tutorial löschen",
    "tutorial.delete.confirmText": "Sind Sie sicher, dass Sie dieses Tutorial löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "tutorial.delete.success": "Tutorial erfolgreich gelöscht",
    "tutorial.list.title": "Tutorials",
    "tutorial.create.button": "Tutorial erstellen",
    "tutorial.start.prompt": "Training starten",
    "tutorial.new-section.prompt": "Führe mich in einen neuen Abschnitt ein",
    "tutorial.search.placeholder": "Tutorials suchen...",
    "tutorial.noDescription": "Keine Beschreibung verfügbar",
    "tutorial.steps": "schritte",
    "tutorial.sections": "abschnitte",
    "tutorial.list.empty.title": "Keine Tutorials gefunden",
    "tutorial.list.empty.message": "Erstellen Sie Ihr erstes Tutorial, um mit interaktiven Lernerfahrungen zu beginnen.",
    "tutorial.form.scanProgress.step": "Schritt",
    "tutorial.form.scanProgress.section": "Abschnitt",
    "tutorial.form.scanProgress.reading": "Quelldatei wird gelesen...",
    "tutorial.form.scanProgress.index": "Struktur wird analysiert und Abschnitte werden geplant...",
    "tutorial.form.scanProgress.content": "Abschnittsinhalt wird geschrieben",
    "tutorial.form.scanProgress.todos": "Aufgaben werden erstellt",
    "tutorial.form.basicInfo": "Grundinformationen",
    "tutorial.form.name": "Tutorial-Name",
    "tutorial.form.description": "Beschreibung",
    "tutorial.form.introText": "Einführungstext",
    "tutorial.form.active": "Aktiv",
    "tutorial.form.steps": "Lernschritte",
    "tutorial.form.stepsDescription": "Wählen Sie die Lernschritte aus, die in dieses Tutorial aufgenommen werden sollen.",
    "tutorial.form.noStepsAvailable": "Keine Lernschritte verfügbar. Erstellen Sie zuerst einige Schritte.",
    "tutorial.form.sections": "Tutorial-Abschnitte",
    "tutorial.form.addSection": "Abschnitt hinzufügen",
    "tutorial.form.sectionsDescription": "Erstellen Sie Abschnitte mit spezifischem Wissen und Prompts für geführtes Lernen.",
    "tutorial.form.section": "Abschnitt",
    "tutorial.form.sectionTitle": "Abschnittstitel",
    "tutorial.form.sectionDescription": "Abschnittsbeschreibung",
    "tutorial.form.sectionPrompt": "Abschnitts-Prompt",
    "tutorial.form.sectionKnowledge": "Wissensbasis",
    "tutorial.form.updatedFromAI": "Formular vom KI-Assistenten aktualisiert",
    "tutorial.preview.introduction": "Einführung",
    "tutorial.preview.learningSteps": "Lernschritte",
    "tutorial.preview.tutorialSections": "Tutorial-Abschnitte",
    "tutorial.preview.knowledgeEntries": "wissenseinträge",
    "tutorial.preview.sectionPrompt": "Abschnitts-Prompt",
    "tutorial.preview.knowledgeBase": "Wissensbasis",
    "tutorial.preview.stepSections": "Schritt-Abschnitte",
    "tutorial.preview.notFound": "Tutorial nicht gefunden",
    "tutorial.preview.notFoundMessage": "Das angeforderte Tutorial konnte nicht gefunden werden oder Sie haben keine Berechtigung, es anzuzeigen.",
    "tutorial.validation.nameRequired": "Tutorial-Name ist erforderlich",
    "tutorial.validation.sectionsRequired": "Mindestens ein Abschnitt ist erforderlich",
    "tutorial.validation.sectionTitleRequired": "Titel für Abschnitt {index} ist erforderlich",
    "tutorial.created": "Tutorial erfolgreich erstellt",
    "tutorial.updated": "Tutorial erfolgreich aktualisiert",
    "tutorial.saveFailed": "Tutorial konnte nicht gespeichert werden",
    "tutorial.loadFailed": "Tutorial konnte nicht geladen werden",
    "tutorial.loadListFailed": "Tutorials konnten nicht geladen werden",
    "tutorial.deleteFailed": "Tutorial konnte nicht gelöscht werden",
    // Form-related translations
    "tutorial.form.namePlaceholder": "Trainingsname eingeben...",
    "tutorial.form.avatar": "Führender Avatar",
    "tutorial.form.avatarPlaceholder": "Wählen Sie einen Avatar für dieses Tutorial",
    "tutorial.form.selectAvatar": "Avatar auswählen...",
    "tutorial.form.company": "Unternehmen / Auftrag",
    "tutorial.form.selectCompany": "Unternehmen auswählen...",
    "tutorial.form.descriptionPlaceholder": "Beschreiben Sie kurz, was in diesem Training behandelt wird...",
    "tutorial.form.introTextPlaceholder": "Schreiben Sie einen Einführungstext, der den Teilnehmer begrüßt...",
    "tutorial.form.step": "Schritt",
    "tutorial.form.addStep": "Schritt hinzufügen",
    "tutorial.form.stepName": "Schrittname",
    "tutorial.form.stepNamePlaceholder": "Schrittname eingeben",
    "tutorial.form.stepDescription": "Schrittbeschreibung",
    "tutorial.form.stepDescriptionPlaceholder": "Schrittbeschreibung eingeben (optional)",
    "tutorial.form.selectStep": "Schritt auswählen...",
    "tutorial.form.sectionName": "Abschnittsname",
    "tutorial.form.sectionNamePlaceholder": "Abschnittsname eingeben...",
    "tutorial.form.sectionIntro": "Abschnittseinführung",
    "tutorial.form.sectionIntroPlaceholder": "Beschreiben Sie, was der Teilnehmer in diesem Abschnitt lernen wird...",
    "tutorial.form.sectionPromptPlaceholder": "Bereitstellen von Wissen oder Anleitung für diesen Abschnitt...",
    "tutorial.form.addKnowledge": "Wissen hinzufügen",
    "tutorial.form.selectedKnowledge": "Ausgewähltes Wissen",
    "tutorial.form.files": "Screenshot / Bildschirm",
    "tutorial.form.screenshot": "Screenshot / Bildschirm",
    "tutorial.form.screenshotPlaceholder": "Screenshot-Datei auswählen...",
    "tutorial.form.video": "Video (MP4)",
    "tutorial.form.videoPlaceholder": "Video-Datei auswählen...",
    "tutorial.form.screenshotMini": "Screenshot-Miniatur",
    "tutorial.form.screenshotMiniPlaceholder": "Screenshot-Miniatur auswählen...",
    "tutorial.form.videoMini": "Video-Miniatur",
    "tutorial.form.videoMiniPlaceholder": "Video-Miniatur auswählen...",
    "tutorial.noTasks": "Keine Aufgaben für diesen Abschnitt verfügbar",
    // Error messages
    "tutorial.errors.stepsLoadFailed": "Schritte konnten nicht geladen werden",
    "tutorial.errors.avatarsLoadFailed": "Avatare konnten nicht geladen werden",
    "tutorial.errors.companiesLoadFailed": "Unternehmen konnten nicht geladen werden",
    "tutorial.errors.loadFailed": "Tutorial konnte nicht geladen werden",
    // Additional validation messages
    "tutorial.validation.stepsRequired": "Mindestens ein Schritt ist erforderlich",
    "tutorial.validation.stepTitleRequired": "Titel für Schritt {index} ist erforderlich",
    "tutorial.validation.stepSectionsRequired": "Schritt {index} muss mindestens einen Abschnitt haben",
    // Additional tutorial translations
    "tutorial.catalog": "Tutorial-Katalog",
    "tutorial.sectionsPlaceholder": "Keine Abschnitte verfügbar",
    "tutorial.yourTraining": "Ihr Training",
    "tutorial.completed": "Abgeschlossen",
    "tutorial.inProgress": "In Bearbeitung",
    "tutorial.notStarted": "Nicht begonnen",
    "tutorial.continue": "Fortsetzen",
    "tutorial.start": "Starten",
    "tutorial.restart": "Neu starten",
    "tutorial.finish": "Abschließen",
    "tutorial.progress": "Fortschritt",
    "tutorial.estimatedTime": "Geschätzte Zeit",
    "tutorial.difficulty": "Schwierigkeit",
    "tutorial.beginner": "Anfänger",
    "tutorial.intermediate": "Fortgeschritten",
    "tutorial.advanced": "Experte",
    "tutorial.prerequisites": "Voraussetzungen",
    "tutorial.objectives": "Lernziele",
    "tutorial.resources": "Ressourcen",
    "tutorial.downloadResources": "Ressourcen herunterladen",
    "tutorial.printInstructions": "Anweisungen drucken",
    "tutorial.shareProgress": "Fortschritt teilen",
    "tutorial.giveF       edback": "Feedback geben",
    "tutorial.reportIssue": "Problem melden",
    "tutorial.certificate": "Zertifikat",
    "tutorial.downloadCertificate": "Zertifikat herunterladen",
    // Todo-related tutorial translations
    "tutorial.form.todoItems": "Todo-Elemente",
    "tutorial.form.todoItemPlaceholder": "Todo-Element eingeben...",
    "tutorial.form.addTodoItem": "Todo hinzufügen",
    "tutorial.form.removeTodoItem": "Todo entfernen",
    "tutorial.form.todoDescription": "Verwalten Sie die Todo-Liste für dieses Tutorial",
    "tutorial.form.noTodoItems": "Keine Todo-Elemente für dieses Tutorial",
    "botTest.create.title": "Bot-Test erstellen",
    "botTest.edit.title": "Bot-Test bearbeiten",
    "botTest.title": "Bot-Test",
    "botTest.name": "Testname",
    "botTest.date": "Datum",
    "botTest.testDate": "Testdatum",
    "botTest.description": "Beschreibung",
    "botTest.testers": "Tester",
    "botTest.targets": "Ziele",
    "botTest.messages": "nachrichten",
    "botTest.noTesters": "Keine Tester verfügbar",
    "botTest.addTester": "Tester hinzufügen",
    "botTest.addTarget": "Ziel hinzufügen",
    "botTest.tester.name": "Testername",
    "botTest.tester.model": "KI-Modell",
    "botTest.model": "Modell",
    "botTest.target.avatar": "Ziel-Avatar",
    "botTest.list.name": "Testname",
    "botTest.list.date": "Testdatum",
    "botTest.list.testersCount": "Tester",
    "botTest.list.targetsCount": "Ziele",
    "botTest.actions.run": "Test ausführen",
    "botTest.actions.results": "Ergebnisse anzeigen",
    // Bot Test Preview
    "botTest.preview.title": "Bot Test Vorschau",
    "botTest.preview.run": "Test Ausführen",
    "botTest.preview.edit": "Test Bearbeiten",
    "botTest.preview.back": "Zurück zur Liste",
    "botTest.preview.section.basic_info": "Grundlegende Informationen",
    "botTest.preview.section.statistics": "Statistiken",
    "botTest.preview.section.testers": "Test-Konfiguration",
    "botTest.preview.not_provided": "Nicht angegeben",
    "botTest.preview.total_testers": "Anzahl Tester",
    "botTest.preview.total_targets": "Anzahl Ziele",
    "botTest.preview.creator": "Erstellt von",
    "botTest.preview.unknown_creator": "Unbekannt",
    "botTest.preview.testers_count": "Tester",
    "botTest.preview.targets_count": "Ziele",
    "botTest.preview.created_date": "Erstellt",
    "botTest.preview.updated_date": "Zuletzt aktualisiert",
    "botTest.preview.tester_configuration": "Tester-Konfiguration",
    "botTest.preview.prompt_overridden": "Prompt überschrieben",
    "botTest.preview.no_targets": "Keine Ziele konfiguriert",
    "botTest.preview.unknown_avatar": "Unbekannter Avatar",
    "botTest.preview.no_testers": "Keine Tester konfiguriert",
    "botTest.preview.no_testers_description": "Fügen Sie Tester hinzu, um die AI-Modelle und Prompts zum Testen zu konfigurieren.",
    "botTest.preview.not_found": "Bot Test nicht gefunden",
    "botTest.preview.not_found_description": "Der angeforderte Bot Test konnte nicht gefunden werden oder wurde gelöscht.",
    "botTest.preview.no_model": "Kein Modell",
    "botTest.preview.unknown_model": "Unbekanntes Modell",
    "botTest.preview.status.unknown": "Unbekannt",
    "botTest.preview.status.active": "Aktiv",
    "botTest.preview.status.inactive": "Inaktiv",
    "botTest.preview.status.standby": "Bereit",
    "botTest.preview.status.pending": "Wartend",
    "botTest.preview.status.running": "Laufend",
    "botTest.preview.status.completed": "Abgeschlossen",
    "botTest.preview.status.failed": "Fehlgeschlagen",
    "botTest.preview.error.load_failed": "Fehler beim Laden des Bot Tests",
    "botTest.preview.run_confirmation": "Sind Sie sicher, dass Sie diesen Test ausführen möchten?",
    "botTest.preview.run_started": "Bot Test erfolgreich gestartet",
    "botTest.preview.run_failed": "Fehler beim Starten des Bot Tests",
    // Bot Test Preview Tabs
    "botTest.preview.tabs.data": "Daten",
    "botTest.preview.tabs.test_results": "Testergebnisse",
    // Bot Test Results
    "botTest.preview.section.test_results": "Testergebnisse",
    "botTest.preview.no_test_results": "Keine Testergebnisse verfügbar",
    "botTest.preview.no_test_results_description": "Führen Sie den Bot-Test aus, um hier Ergebnisse zu sehen.",
    "botTest.preview.model": "Modell",
    "botTest.preview.temperature": "Temperatur",
    "botTest.preview.completed": "Abgeschlossen",
    "botTest.preview.failed": "Fehlgeschlagen",
    "botTest.preview.status": "Status",
    "botTest.preview.messages": "Nachrichten",
    "botTest.preview.tokens": "Token",
    "botTest.preview.duration": "Dauer",
    "botTest.preview.total_messages": "Gesamt Nachrichten",
    "botTest.preview.total_tokens": "Gesamt Token",
    "botTest.preview.avg_duration": "Durchschn. Dauer",
    // Bot Test Results
    "botTest.testResults.title": "Testergebnisse",
    "botTest.testResults.results": "Ergebnisse",
    "botTest.testResults.result": "Ergebnis",
    "botTest.testResults.metrics": "Metriken",
    "botTest.testResults.totalMessages": "Gesamt Nachrichten",
    "botTest.testResults.totalTokens": "Gesamt Token",
    "botTest.testResults.totalCost": "Gesamtkosten",
    "botTest.testResults.executionTime": "Ausführungszeit",
    "botTest.testResults.averageResponseTime": "Durchschnittliche Fragenbearbeitungszeit",
    "botTest.testResults.inputTokens": "Eingabe-Token",
    "botTest.testResults.outputTokens": "Ausgabe-Token",
    "botTest.testResults.messageCount": "Nachrichten",
    "botTest.testResults.error": "Fehler",
    "botTest.testResults.response": "KI-Antwort",
    "botTest.testResults.questionGeneration": "Fragengenerierung",
    "botTest.testResults.success": "Erfolg",
    "botTest.testResults.tokens": "Token",
    "botTest.testResults.cost": "Kosten",
    "botTest.testResults.status.pending": "Wartend",
    "botTest.testResults.status.running": "Laufend",
    "botTest.testResults.status.completed": "Abgeschlossen",
    "botTest.testResults.status.failed": "Fehlgeschlagen",
    "botTest.testResults.questionsAndAnswers": "Fragen & Antworten",
    "botTest.testResults.question": "Frage",
    "botTest.testResults.questionLabel": "F",
    "botTest.testResults.answerLabel": "A",
    "botTest.testResults.answerStartTime": "Antwortzeit (erster Token)",
    "botTest.testResults.no_results": "Keine Testergebnisse verfügbar",
    "botTest.testResults.no_results_description": "Führen Sie den Test aus, um hier Ergebnisse zu sehen.",
    "route.ai": "KI-Chat",
    "route.ai.chat": "KI-Chat",
    "route.share": "Geteilte Konversation",
    // Misc
    "misc.loading": "Laden...",
    "misc.yes": "Ja",
    "misc.no": "Nein",
    // Login labels
    "login.usernameLabel": "Login/E-Mail",
    "login.passwordLabel": "Passwort",
    "ai.models.source": "KI-Quelle",
    "ai.com.choose_model": "Modell wählen",
    "ai.com.choose_provider": "Anbieter wählen",
    "ai.com.choose_avatar": "Avatar wählen",
    "ai.fields.model_composite": "Ausgewähltes Modell",
    "ai.controls.knowledgePicker.label": "Wissen auswählen",
    "ai.controls.knowledgePicker.show": "Wissensbasis verwenden",
    "ai-assist.header": "KI-Assistent",
    "ai-assist.minimize": "Minimieren",
    "ai-assist.expand": "Erweitern",
    "ai-assist.suggestions.header": "KI-Vorschläge",
    "ai-assist.suggestions.close": "Schließen",
    "ai-assist.suggestions.intro": "Wählen Sie einen Vorschlag aus, um ihn auf Ihren Prompt anzuwenden:",
    "ai-assist.info": "Der KI-Assistent analysiert Ihre Prompts und Gespräche und bietet Vorschläge, um bessere Ergebnisse zu erzielen. Sie können ihn in den Chat-Einstellungen in der rechten unteren Ecke des Chat-Eingabebereichs deaktivieren",
    "ai-assist.no-entries": "Starten Sie ein Gespräch, um die KI-Assistenten-Hilfe zu aktivieren",
    "knowledge.picker.tooltip": "Wählen Sie Dateien für den KI-Assistenten aus oder fügen Sie Ihre eigenen hinzu",
    "modelSelect.instruction": "Wählen Sie Ihren Avatar oder Ihr KI-Modell aus, mit dem Sie sprechen möchten",
    "modelSelect.knowledgeCreatingInProgress": "Wissensdatenbank-Eintrag wird erstellt...",
    // AI Suggestions Component
    "ai.suggestions.title": "KI-Prompt-Verbesserung",
    "ai.suggestions.description": "Wählen Sie einen oder mehrere Vorschläge aus, um sie zur Überprüfung in Ihren Prompt einzufügen. Sie können dann manuell bearbeiten und absenden.",
    "ai.suggestions.apply": "Vorschläge anwenden",
    "ai.suggestions.clarification": "Zusätzliche Erläuterung",
    "ai.suggestions.clarification.label": "Zusätzliche Erläuterung (optional)",
    "ai.suggestions.clarification.placeholder": "Fügen Sie spezifische Anforderungen oder Kontext hinzu...",
    "ai.suggestions.context.prompt": "Aus Eingabe",
    "ai.suggestions.context.message": "Letzte Nachricht",
    // AI Assist Component
    "ai.assist.attachKnowledge": "Wissen anhängen:",
    "ai.assist.knowledgeFound": "Relevantes Wissen gefunden",
    "ai.assist.relevantKnowledgeFound": "Relevantes Wissen nach Gespräch gefunden",
    "ai.assist.attachmentIds": "Anhang-IDs",
    // Model Select Component
    "modelSelect.models": "Modelle",
    "modelSelect.avatars": "Avatare",
    "modelSelect.liveChats": "Live-Chats",
    "modelSelect.voiceModels": "Sprachmodelle",
    "ai.chat.nomodel": "Modell auswählen, um zu chatten",
    // Konversations-Übersetzungen
    "conversations.title": "Konversationen",
    "conversations.search.placeholder": "Konversationen suchen...",
    "conversations.loading": "Konversationen werden geladen...",
    "conversations.retry": "Erneut versuchen",
    "conversations.empty": "Keine Konversationen gefunden",
    "conversations.date.today": "Heute",
    "conversations.date.yesterday": "Gestern",
    "conversations.date.daysAgo": "vor {days} Tagen",
    "conversations.error.failedToLoad": "Konversationen konnten nicht geladen werden",
    "conversations.delete.tooltip": "Konversation löschen",
    "conversations.delete.confirm": "Sind Sie sicher, dass Sie \"{title}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "conversations.error.failedToDelete": "Konversation konnte nicht gelöscht werden",
    "conversations.favorite.add": "Zu Favoriten hinzufügen",
    "conversations.favorite.remove": "Aus Favoriten entfernen",
    "conversations.error.failedToToggleFavorite": "Favoritenstatus konnte nicht geändert werden",
    "conversations.chat_history": "Chat-Verlauf",
    "conversations.no_conversations_yet": "Noch keine Gespräche",
    "conversations.no_messages_yet": "Noch keine Nachrichten",
    "conversations.loading_more": "Weitere laden...",
    "conversations.no_more_conversations": "Keine weiteren Gespräche",
    "conversations.new_chat": "Neuer Thread",
    "conversations.listTitle": "Konversationen",
    "conversations.newConversation": "Neue Konversation",
    "conversations.search_placeholder": "Konversationen suchen...",
    "conversations.failedToLoad": "Konversationen konnten nicht geladen werden",
    "conversations.failedToLoadMessages": "Nachrichten konnten nicht geladen werden",
    "conversations.delete.success": "Konversation erfolgreich gelöscht",
    "conversations.delete.error": "Konversation konnte nicht gelöscht werden",
    "conversations.delete.action": "Löschen",
    "conversations.tooltips.preview": "Konversation anzeigen",
    "conversations.tooltips.delete": "Konversation löschen",
    "conversations.last_activity": "Letzte Aktivität",
    "conversations.lastActivity": "Letzte Aktivität",
    "conversations.model": "Modell",
    "conversations.avatar": "Avatar",
    "conversations.openInChat": "Im Chat öffnen",
    "conversations.user": "Benutzer",
    "conversations.assistant": "Assistent",
    "conversations.noMessages": "Keine Nachrichten in dieser Konversation",
    // Allgemeine Aktionen
    "common.create": "Erstellen",
    "common.update": "Aktualisieren",
    "common.cancel": "Abbrechen",
    "common.close": "Schließen",
    "common.back": "Zurück",
    "common.clear": "Löschen",
    "common.apply": "Anwenden",
    "common.hide": "Ausblenden",
    "common.moveUp": "Nach oben verschieben",
    "common.moveDown": "Nach unten verschieben",
    "common.delete": "Löschen",
    "common.results": "Ergebnisse",
    "common.optional": "(Optional)",
    "common.none": "Keine",
    "common.pay": "Bezahlen",
    "common.loading": "Laden...",
    "common.unknown": "Unbekannt",
    "common.showing": "Zeige",
    "common.to": "bis",
    "common.of": "von",
    "common.next": "Weiter",
    "common.previous": "Zurück",
    // Kontoverwaltung
    "account.upgrade.title": "Konto-Upgrade",
    "account.upgrade.currentGrade": "Aktuelle Kontostufe",
    "account.upgrade.selectGrade": "Ihr Plan",
    "account.upgrade.save": "Änderungen speichern",
    "account.upgrade.payNow": "Jetzt bezahlen & upgraden",
    "account.upgrade.downgrade": "Zu günstigerem Plan wechseln",
    "account.upgrade.mostPopular": "Beliebteste",
    "account.upgrade.selectPlan": "Plan auswählen",
    "account.upgrade.selected": "Ausgewählt",
    "account.upgrade.success": "Kontostufe erfolgreich aktualisiert",
    "account.upgrade.errors.general": "Kontostufe konnte nicht aktualisiert werden",
    "account.upgrade.errors.loadUser": "Benutzerinformationen konnten nicht geladen werden",
    "account.upgrade.errors.noUser": "Benutzer nicht gefunden",
    "account.upgrade.credits": "Credits",
    "account.upgrade.noCredits": "Keine Credits enthalten",
    "account.upgrade.perMonth": "pro Monat",
    "account.upgrade.changePlan": "Plan ändern",
    "account.upgrade.currentPlan": "Aktueller Plan",
    "account.upgrade.futureGradeInfo": "Dieser Plan wird aktiviert am",
    "account.upgrade.confirm.title": "Plan-Änderung bestätigen",
    "account.upgrade.confirm.downgrade": "Sind Sie sicher, dass Sie auf den kostenlosen Plan downgraden möchten? Sie verlieren den Zugang zu Premium-Funktionen.",
    "account.upgrade.confirm.change": "Sind Sie sicher, dass Sie Ihren Plan ändern möchten zu",
    "account.upgrade.success.changed": "Ihr Plan wurde erfolgreich geändert",
    "account.upgrade.success.upgraded": "Konto erfolgreich aufgewertet!",
    "account.upgrade.paymentInitiated": "Zahlung eingeleitet. Bitte schließen Sie die Zahlung ab, um Ihr Konto zu erweitern.",
    "account.upgrade.errors.changeFailed": "Plan-Änderung fehlgeschlagen",
    "account.upgrade.errors.paymentFailed": "Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "account.upgrade.monthly": "Monatlich",
    "account.upgrade.yearly": "Jährlich",
    "account.upgrade.saveMore": "Mehr Sparen",
    "account.upgrade.discount": "RABATT",
    "account.upgrade.save_money_amount": "Sparen", // Kontostufen
    "account.grades.free": "Kostenlos",
    "account.grades.free.description": "Grundfunktionen für den Einstieg",
    "account.grades.free.feature1": "Begrenzte monatliche Nutzung",
    "account.grades.free.feature2": "Basis-KI-Modelle",
    "account.grades.free.feature3": "Community-Support",
    "account.grades.basic": "Basic",
    "account.grades.basic.description": "Erweiterte Funktionen für normale Benutzer",
    "account.grades.basic.feature1": "Erhöhte monatliche Nutzung",
    "account.grades.basic.feature2": "Standard-KI-Modelle",
    "account.grades.basic.feature3": "E-Mail-Support",
    "account.grades.pro": "Pro",
    "account.grades.pro.description": "Erweiterte Funktionen für Profis",
    "account.grades.pro.feature1": "Hohe monatliche Nutzung",
    "account.grades.pro.feature2": "Premium-KI-Modelle",
    "account.grades.pro.feature3": "Prioritäts-Support",
    "account.grades.ultra": "Ultra",
    "account.grades.ultra.description": "Maximale Funktionen für Power-User",
    "account.grades.ultra.feature1": "Unbegrenzte Nutzung",
    "account.grades.ultra.feature2": "Alle KI-Modelle",
    "account.grades.ultra.feature3": "Dedizierter Support",
    // Wissens-Routen
    "route.knowledge.list": "Wissensbasis",
    "route.knowledge.create": "Wissen hinzufügen",
    "route.knowledge.edit": "Wissen bearbeiten",
    "route.knowledge.preview": "Wissensdetails",
    "route.knowledgeProject.list": "Projekte",
    "route.knowledgeProject.create": "Projekt hinzufügen",
    "route.knowledgeProject.edit": "Projekt bearbeiten",
    // Wissens-Übersetzungen
    "knowledge.create": "Wissen erstellen",
    "knowledge.title": "Titel",
    "knowledge.title.placeholder": "Wissenstitel eingeben",
    "knowledge.description": "Beschreibung",
    "knowledge.description.placeholder": "Wissensbeschreibung eingeben",
    "knowledge.content": "Inhalt",
    "knowledge.content.placeholder": "Wissensinhalt eingeben",
    "knowledge.file": "Datei",
    "knowledge.tags": "Tags",
    "knowledge.tags.placeholder": "Tags durch Kommas getrennt eingeben",
    "knowledge.tags.help": "Drücken Sie Enter, um jeden Tag hinzuzufügen",
    "knowledge.project": "Projekt",
    "knowledge.creator": "Ersteller",
    "knowledge.ragStatus": "RAG-Status",
    "knowledge.assigned": "Zugewiesen",
    "knowledge.createdAt": "Erstellt am",
    "knowledge.no_project": "Kein Projekt",
    "knowledge.active": "Aktiv",
    "knowledge.active.help": "Dieses Wissen zur Nutzung aktivieren",
    "knowledge.filter.project": "Nach Projekt filtern",
    "knowledge.filter.project.placeholder": "Projekte suchen...",
    "knowledge.picker.search.mode": "Suchmodus",
    "knowledge.picker.search.knowledge": "Wissenseinträge",
    "knowledge.picker.search.projects": "Projekte",
    "knowledge.picker.search.knowledge.label": "Wissenseinträge suchen - Wissen dem Avatar zuweisen",
    "knowledge.picker.search.knowledge.placeholder": "Wissenseinträge suchen...",
    "knowledge.picker.search.projects.label": "Projekte suchen - Projekt dem Avatar zuweisen",
    "knowledge.picker.search.projects.placeholder": "Projekte suchen...",
    "knowledge.picker.search.clear": "Suche löschen",
    "knowledge.picker.selected.knowledge": "Ausgewählte Wissenseinträge",
    "knowledge.picker.selected.projects": "Ausgewählte Projekte",
    "knowledge.picker.table.name": "Name",
    "knowledge.picker.table.project": "Projekt",
    "knowledge.picker.table.format": "Format",
    "knowledge.picker.table.size": "Größe",
    "knowledge.picker.table.description": "Beschreibung",
    "knowledge.picker.remove": "Entfernen",
    "knowledge.picker.confirmRemove": "Sind Sie sicher, dass Sie diesen Wissenseintrag entfernen möchten?",
    "knowledge.picker.no.results": "Keine Elemente gefunden",
    "knowledge.picker.1to1mode": "1:1 Modus (Vollinhalt)",
    "knowledge.filter.all_projects": "Alle Projekte",
    "knowledge.filter.assigned_only": "Nur zugewiesenes Wissen anzeigen",
    "knowledge.filter.by_avatar": "Nach Avatar filtern",
    "knowledge.filter.all_avatars": "Alle Avatare",
    "project.manage": "Projekte verwalten",
    "project.none": "Kein Projekt",
    "project.form.title.edit": "Projekt bearbeiten",
    "project.form.title.add": "Projekt hinzufügen",
    "project.form.back": "Zurück",
    "project.form.color.placeholder": "#007bff",
    "project.form.icon.placeholder": "Projekt-Symbol wählen",
    "project.name": "Projektname",
    "project.name.placeholder": "Projektname eingeben",
    "project.description": "Beschreibung",
    "project.description.placeholder": "Projektbeschreibung eingeben",
    "project.color": "Farbe",
    "project.icon": "Symbol",
    "project.icon.help": "FontAwesome-Symbolklasse eingeben (z.B. fas fa-folder)",
    "project.isActive": "Aktiv",
    "project.preview": "Vorschau",
    "project.list": "Projekte",
    "project.create": "Projekt hinzufügen",
    "project.edit": "Projekt bearbeiten",
    "project.creator": "Ersteller",
    "knowledge.native": "Natives Wissen",
    "knowledge.native.help": "Natives Wissen ist für normale Benutzer verborgen, aber für KI-Assistenten verfügbar",
    // RAG Status translations
    "knowledge.ragStatus.pending": "Wartend",
    "knowledge.ragStatus.processing": "Verarbeitung",
    "knowledge.ragStatus.completed": "Abgeschlossen",
    "knowledge.ragStatus.failed": "Fehlgeschlagen",
    "knowledge.ragStatus.not_indexed": "Nicht zutreffend",
    "knowledge.statusInfo.images": "Bilder",
    "knowledge.reindex": "Neu indexieren",
    "knowledge.reindexingStarted": "Neuindexierung wurde gestartet",
    // Knowledge Form Übersetzungen
    "knowledge.form.title.edit": "Wissen bearbeiten",
    "knowledge.form.title.add": "Wissen hinzufügen",
    "knowledge.form.back": "Zurück",
    "knowledge.form.title.label": "Titel",
    "knowledge.form.title.placeholder": "Wissenstitel eingeben",
    "knowledge.form.description.label": "Beschreibung",
    "knowledge.form.description.placeholder": "Wissensbeschreibung eingeben",
    "knowledge.form.description.help": "Geben Sie eine kurze Beschreibung ein, um dieses Wissen zu identifizieren",
    "knowledge.form.content.label": "Inhalt",
    "knowledge.form.content.placeholder": "Wissensinhalt eingeben",
    "knowledge.form.file.label": "Datei",
    "knowledge.form.file.placeholder": "Datei auswählen",
    "knowledge.form.project.label": "Projekt",
    "knowledge.form.project.placeholder": "Projekt auswählen",
    "knowledge.form.tags.label": "Tags",
    "knowledge.form.tags.placeholder": "Tags durch Kommas getrennt eingeben",
    "knowledge.form.tags.help": "Enter drücken um Tags hinzuzufügen",
    "knowledge.form.contentType.label": "Inhaltstyp",
    "knowledge.form.contentType.help": "Wählen Sie den Typ des Inhalts aus, den Sie hinzufügen möchten",
    "knowledge.form.contentType.text": "Text",
    "knowledge.form.contentType.file": "Datei",
    "knowledge.form.contentType.link": "Link",
    "knowledge.form.contentType.googleDrive": "Google Drive",
    "knowledge.form.contentType.google-drive": "Google Drive",
    "knowledge.form.link.label": "Link URL",
    "knowledge.form.link.placeholder": "URL des Links eingeben",
    "knowledge.form.googleDrive.label": "Google Drive URL",
    "knowledge.form.googleDrive.placeholder": "Google Drive Freigabe-URL eingeben",
    "knowledge.form.active.label": "Aktiv",
    "knowledge.form.active.help": "Dieses Wissen zur Nutzung aktivieren",
    "knowledge.form.rag_status.label": "RAG-Status",
    "knowledge.form.content_type.label": "Inhaltstyp",
    "knowledge.form.submit.update": "Wissen aktualisieren",
    "knowledge.form.submit.create": "Wissen erstellen",
    "knowledge.form.reset.debug": "Formular wird auf Ausgangszustand zurückgesetzt",
    "knowledge.form.reset.complete": "Formular-Teile wurden zurückgesetzt",
    "knowledge.form.reset.forNext": "Formular für nächsten Eintrag zurücksetzen",
    "knowledge.form.projects.loadError": "Fehler beim Laden der Projekte:",
    "knowledge.form.load.error": "Fehler beim Laden des Wissens",
    "knowledge.form.submit.duplicateWarning": "Formular wird bereits übermittelt, doppelte Übermittlung wird ignoriert",
    "knowledge.form.submit.starting": "Formular-Übermittlung startet mit Daten:",
    "knowledge.form.submit.updating": "Wissen wird aktualisiert mit ID:",
    "knowledge.form.submit.creating": "Neuer Wissenseintrag wird erstellt",
    "knowledge.form.submit.updateError": "Fehler beim Aktualisieren des Wissens",
    "knowledge.form.submit.createError": "Fehler beim Erstellen des Wissens",
    "knowledge.form.submit.updateSuccess": "Wissen erfolgreich aktualisiert",
    "knowledge.form.submit.createSuccess": "Wissen erfolgreich erstellt",
    "knowledge.form.submit.success": "Wissen erfolgreich erstellt:",
    "knowledge.form.submit.error": "Fehler beim Speichern des Wissens:",
    "knowledge.form.validation.fileRequired": "Datei ist erforderlich",
    "knowledge.form.validation.timedDatesRequired": "Sowohl Start- als auch Endzeit sind erforderlich, wenn zeitgesteuert aktiviert ist",
    "knowledge.form.fileProcessing.completed": "Dateierarbeitung erfolgreich abgeschlossen",
    "knowledge.form.fileProcessing.failed": "Dateierarbeitung fehlgeschlagen",
    // Massen-Upload Wissen Übersetzungen
    "knowledge.bulk_upload.button": "Massen-Upload",
    "knowledge.bulk_upload.title": "Massen-Upload von Wissensdateien",
    "knowledge.bulk_upload.description": "Mehrere Dateien hochladen, um automatisch Wissenseinträge zu erstellen",
    "knowledge.bulk_upload.files": "Dateien auswählen",
    "knowledge.bulk_upload.files_placeholder": "Klicken Sie, um Dateien auszuwählen oder ziehen Sie mehrere Dateien hierher",
    "knowledge.bulk_upload.files_help": "Unterstützte Formate: PDF, DOC, DOCX, TXT, MD, HTML, RTF, CSS, SCSS, JS/TS + Archive (ZIP, TAR, etc.)",
    "knowledge.bulk_upload.archive_support": "Archivdateien (ZIP, TAR, etc.) werden automatisch extrahiert und Dokumentdateien verarbeitet",
    "knowledge.bulk_upload.project_help": "Wählen Sie ein Projekt, um die hochgeladenen Wissensdateien zu organisieren",
    "knowledge.bulk_upload.upload": "Dateien hochladen",
    "knowledge.bulk_upload.uploading": "Wird hochgeladen...",
    "knowledge.bulk_upload.processing": "Dateien werden verarbeitet...",
    "knowledge.bulk_upload.info.title": "Upload-Informationen",
    "knowledge.bulk_upload.info.title_from_filename": "Dateinamen werden als Wissenseintrag-Titel verwendet (ohne Erweiterung)",
    "knowledge.bulk_upload.info.description_auto": "Beschreibungen werden automatisch aus Dateinamen generiert",
    "knowledge.bulk_upload.info.group_optional": "Projekt-Zuordnung ist optional",
    "knowledge.bulk_upload.info.tags_shared": "Tags werden auf alle hochgeladenen Dateien angewendet",
    "knowledge.bulk_upload.info.rag_auto_index": "Dateien werden automatisch im RAG-System indexiert",
    "knowledge.bulk_upload.info.archive_extraction": "Archivdateien werden extrahiert und Dokumentdateien darin automatisch verarbeitet",
    "knowledge.bulk_upload.tags_help": "Diese Tags werden auf alle hochgeladenen Wissensdateien angewendet",
    // Google Drive bulk upload
    "knowledge.bulk_upload.upload_mode": "Upload-Modus",
    "knowledge.bulk_upload.mode.files": "Dateien hochladen",
    "knowledge.bulk_upload.mode.google_drive_directory": "Google Drive Ordner",
    "knowledge.bulk_upload.google_drive_not_connected": "Google Drive nicht verbunden. Bitte verbinden Sie es zuerst in den Einstellungen.",
    "knowledge.bulk_upload.google_drive_setup_required": "Verbinden Sie Google Drive in den Einstellungen, um diese Funktion zu nutzen.",
    "knowledge.bulk_upload.google_drive_directory": "Google Drive Ordner",
    "knowledge.bulk_upload.google_drive_directory_help": "Wählen Sie einen Google Drive Ordner aus, um Wissenseinträge aus allen darin enthaltenen Dateien zu erstellen",
    "knowledge.bulk_upload.selected_directory": "Ausgewählter Ordner",
    "knowledge.bulk_upload.process_directory": "Ordner verarbeiten",
    "knowledge.bulk_upload.processing_directory": "Ordner wird verarbeitet...",
    // Google Drive bulk upload info
    "knowledge.bulk_upload.info.google_drive.title_from_filename": "Google Drive Dateinamen werden als Wissenseintrag-Titel verwendet",
    "knowledge.bulk_upload.info.google_drive.content_from_drive": "Dateiinhalte werden während der Indexierung von Google Drive abgerufen",
    "knowledge.bulk_upload.info.google_drive.group_optional": "Projekt-Zuordnung ist optional",
    "knowledge.bulk_upload.info.google_drive.tags_shared": "Tags werden auf alle Wissenseinträge angewendet",
    "knowledge.bulk_upload.info.google_drive.rag_auto_index": "Alle Dateien werden automatisch im RAG-System indexiert",
    "knowledge.bulk_upload.info.google_drive.supported_types": "Unterstützt Google Docs, Sheets, Slides, PDFs, Textdateien und Office-Dokumente",
    // Knowledge preview
    "knowledge.preview": "Wissensvorschau",
    "knowledge.preview.title": "Wissensdetails",
    "knowledge.preview.edit": "Bearbeiten",
    "knowledge.preview.back": "Zurück zur Liste",
    "knowledge.preview.not_found": "Wissensdatei nicht gefunden",
    "knowledge.preview.not_provided": "Nicht angegeben",
    "knowledge.preview.no_tags": "Keine Tags",
    "knowledge.preview.no_file": "Keine Datei angehängt",
    "knowledge.preview.error.load_failed": "Laden der Wissensdatei fehlgeschlagen",
    // Knowledge preview sections
    "knowledge.preview.section.basic_info": "Grundinformationen",
    "knowledge.preview.section.file_info": "Dateiinformationen",
    "knowledge.preview.section.content": "Inhalt",
    "knowledge.preview.section.used_by_avatars": "Verwendet von Avataren",
    "knowledge.preview.section.used_by_professions": "Verwendet von Berufen",
    "knowledge.preview.section.errors": "Fehler",
    // Knowledge preview content type labels
    "knowledge.preview.content_type.text": "Text",
    "knowledge.preview.content_type.file": "Datei",
    "knowledge.preview.content_type.link": "Link",
    "knowledge.preview.content_type.google-drive": "Google Drive",
    // Knowledge preview RAG status labels
    "knowledge.preview.rag_status.pending": "Ausstehend",
    "knowledge.preview.rag_status.processing": "Verarbeitung",
    "knowledge.preview.rag_status.completed": "Abgeschlossen",
    "knowledge.preview.rag_status.failed": "Fehlgeschlagen",
    "knowledge.preview.rag_status.not_indexed": "Nicht indiziert",
    // Knowledge preview active status
    "knowledge.preview.active.yes": "Ja",
    "knowledge.preview.active.no": "Nein",
    // Knowledge preview usage
    "knowledge.preview.no_avatars_using": "Kein Avatar verwendet derzeit dieses Wissen",
    "knowledge.preview.no_professions_using": "Kein Beruf verwendet derzeit dieses Wissen",
    "route.knowledge.bulk_upload": "Massen-Upload Wissen",
    // Projekt-Übersetzungen
    // Project form
    "knowledgeProject.form.title.edit": "Projekt bearbeiten",
    "knowledgeProject.form.title.add": "Projekt hinzufügen",
    "knowledgeProject.form.back": "Zurück",
    "knowledgeProject.form.color.placeholder": "#007bff",
    "knowledgeProject.form.icon.placeholder": "fas fa-folder",
    // Project general
    "knowledgeProject.name": "Projektname",
    "knowledgeProject.name.placeholder": "Projektname eingeben",
    "knowledgeProject.description": "Beschreibung",
    "knowledgeProject.description.placeholder": "Projektbeschreibung eingeben",
    "knowledgeProject.color": "Farbe",
    "knowledgeProject.icon": "Symbol",
    "knowledgeProject.icon.help": "FontAwesome-Symbolklasse eingeben (z.B. fas fa-folder)",
    "knowledgeProject.isActive": "Aktiv",
    "knowledgeProject.preview": "Vorschau",
    "knowledgeProject.list": "Projekte",
    "knowledgeProject.create": "Projekt hinzufügen",
    // Chat component translations
    "chat.teaser.cta.label": "Frage stellen",
    "chat.heading.chat": "Beginnen Sie das Gespräch mit Ihrem KI-Assistenten",
    "chat.heading.ask": "Stellen Sie Ihre Frage",
    "chat.teaser.default.prompt1.description": "Woraus besteht die Atmosphäre des Mars?",
    "chat.teaser.default.prompt1.text": "Woraus besteht die Atmosphäre des Mars?",
    "chat.teaser.default.prompt2.description": "Wie schnell kann ein Pferd laufen?",
    "chat.teaser.default.prompt2.text": "Wie schnell kann ein Pferd laufen?",
    "chat.teaser.default.prompt3.description": "Wie wechselt man einen platten Reifen?",
    "chat.teaser.default.prompt3.text": "Wie wechselt man einen platten Reifen?",
    "chat.config.display.default.prompts.button": "Nicht sicher, was Sie fragen sollen? Probieren Sie unsere Vorschläge!",
    "chat.config.button.label.text": "Eingabeaufforderung senden",
    "chat.config.cancel.button.label.text": "Generierung abbrechen",
    "chat.config.voice.button.label.text": "voice input",
    "chat.config.voice.rec.button.label.text": "Höre auf Spracheingabe",
    "chat.config.input.newline.helper": " für neue Zeile",
    "chat.config.autocomplete.styles.helper": " für Stile",
    "chat.config.autocomplete.projects.helper": " für Projekte",
    "chat.config.autocomplete.knowledge.helper": " für Wissen",
    "chat.config.live_chat.button.label.text": "Live chat",
    "chat.noCredits.message": "Sie haben nicht genügend Credits, um den Chat-Service zu nutzen. Bitte kaufen Sie mehr Credits, um fortzufahren.",
    "chat.config.input.placeholder": "Geben Sie Ihre Frage ein, z.B. \"Wie kann ich Ihnen helfen?\"",
    "chat.config.user.is.bot": "Support-Assistent",
    "chat.config.reset.button.label.text": "X",
    "chat.config.reset.button.title.text": "Aktuelle Frage zurücksetzen",
    "chat.config.reset.chat.button.title": "Chat zurücksetzen",
    "chat.config.copy.response.button.label.text": "Antwort kopieren",
    "chat.config.copied.successfully.message": "Antwort kopiert!",
    "chat.config.follow.up.questions.label.text": "Sie können auch fragen...",
    "chat.config.show.thought.process.button.label.text": "Denkprozess anzeigen",
    "chat.config.hide.thought.process.button.label.text": "Denkprozess verbergen",
    "chat.config.loading.indicator.text": "Bitte warten. Wir suchen und generieren eine Antwort...",
    "chat.config.loading.text": "Laden...",
    "chat.config.api.error.message": "Entschuldigung, wir haben einige Probleme. Bitte versuchen Sie es später noch einmal.",
    "chat.config.invalid.request.error": "Für diese Anfrage kann keine Antwort generiert werden. Bitte ändern Sie Ihre Frage und versuchen Sie es erneut.",
    "chat.config.thought.process.label": "Denkprozess",
    "chat.config.support.context.label": "Support-Kontext",
    "chat.config.reasoning.label": "Begründung",
    "chat.config.citations.label": "Mehr erfahren:",
    "chat.config.citations.tab.label": "Zitate",
    "chat.config.branding.logo.alt": "Markenlogo",
    "chat.config.branding.headline": "Willkommen beim Support-Assistenten unserer Marke",
    "chat.config.show.chat.history.label": "Chat-Verlauf anzeigen",
    "chat.config.hide.chat.history.label": "Chat-Verlauf verbergen",
    "chat.config.chat.history.footer.text": "Zeige die letzten {MAX_CHAT_HISTORY} Unterhaltungen",
    "chat.config.web.search.checkbox.label": "Websuche verwenden",
    // File Upload
    "file.upload.choose": "Datei auswählen...",
    "file.upload.change": "Datei ändern",
    "file.upload.remove": "Datei entfernen",
    "file.upload.loading": "Laden...",
    "file.upload.drop": "Datei hier ablegen",
    "file.upload.download": "Datei herunterladen",
    "file.upload.choose_multiple": "Dateien auswählen...",
    "file.upload.change_multiple": "Dateien ändern",
    "file.upload.remove_all": "Alle Dateien entfernen",
    "file.upload.error.size_too_large": "Datei \"{fileName}\" ist zu groß. Maximale Dateigröße beträgt 2MB.",
    "file.upload.error.size_exceeded_10mb": "Datei \"{fileName}\" ist zu groß. Maximale Dateigröße beträgt {maxSize}.",
    "file.upload.error.multiple_files_size_exceeded_10mb": "Die folgenden Dateien sind zu groß: {fileNames}. Maximale Dateigröße beträgt {maxSize}.",
    "file.upload.error.image_too_large": "Bild \"{filename}\" ({size}) ist zu groß. Bilder müssen unter {maxSize} sein.",
    "file.upload.error.unsupported_type": "Nicht unterstützter Dateityp. Bitte wählen Sie ein unterstütztes Dateiformat.",
    "file.upload.confirm.add_to_knowledge": "Datei \"{fileName}\" ({fileSize}) ist zu groß für den Chat. Möchten Sie sie stattdessen zur Wissensbasis hinzufügen?",
    "file.upload.error.total_size_exceeded": "Das Hinzufügen dieser Datei würde das 5MB-Gesamtlimit überschreiten. Aktuelle Gesamtgröße: {currentSize}, versucht hinzuzufügen: {newSize}.",
    "file.upload.error.processing_failed": "Fehler beim Verarbeiten der Datei \"{fileName}\": {error}",
    "file.upload.error.upload_failed": "Fehler beim Hochladen der Dateien: {error}",
    "file.upload.error.submission_failed": "Fehler beim Chat-Submit: {error}",
    "file.clipboard.images_pasted": "{count} Bild(er) aus der Zwischenablage eingefügt",
    "file.ext": "Dateityp",
    "file.size": "Dateigröße",
    // Popup-Nachrichten
    "popup.error": "Fehler",
    "popup.alert": "Warnung",
    "popup.confirm": "Bestätigen",
    "popup.ok": "OK",
    "popup.yes": "Ja",
    "popup.no": "Nein",
    // LLM Trainer
    "trainer.title": "LLM-Modell-Trainer",
    "trainer.reset.button": "Trainer zurücksetzen",
    "trainer.tab.instructions": "Anweisungen",
    "trainer.tab.upload": "Daten hochladen",
    "trainer.tab.config": "Training konfigurieren",
    "trainer.tab.training": "Trainingsfortschritt",
    "trainer.tab.results": "Ergebnisse",
    "trainer.listTitle": "Trainerliste",
    "trainer.jobId": "Job-ID",
    "trainer.modelName": "Modellname",
    "trainer.trainingType": "Trainingsart",
    "trainer.status": "Status",
    "trainer.createdAt": "Erstellt am",
    "trainer.updatedAt": "Aktualisiert am",
    "trainer.addJob": "Job hinzufügen",
    // Upload-Komponente
    "trainer.upload.mode.title": "Dateneingabemethode wählen",
    "trainer.upload.mode.file": "CSV-Datei hochladen",
    "trainer.upload.mode.manual": "Manuelle Eingabe",
    "trainer.upload.mode.pdf": "PDF-Verarbeitung",
    "trainer.upload.mode.file.description": "Eine vorformatierte CSV-Datei mit Ihren Trainingsdaten hochladen",
    "trainer.upload.mode.manual.description": "Trainingsdaten mit einer benutzerfreundlichen Formulareingabe erstellen",
    "trainer.upload.mode.pdf.description": "Ein PDF hochladen, um automatisch Text zu extrahieren und Trainingsdaten aus Kapiteln zu generieren",
    "trainer.upload.title": "Trainingsdaten hochladen (CSV)",
    "trainer.upload.format.required": "Erforderliches CSV-Format:",
    "trainer.upload.format.input": "Der Prompt-/Fragetext",
    "trainer.upload.format.output": "Die erwartete Antwort/Ausgabe",
    "trainer.upload.format.category": "Klassifizierungskategorie",
    "trainer.upload.format.optional": "optional",
    "trainer.upload.format.metadata": "Zusätzliche Metadaten-Spalten werden unterstützt und bleiben erhalten.",
    "trainer.upload.processing": "Datei wird verarbeitet...",
    "trainer.upload.select": "CSV-Datei auswählen",
    "trainer.upload.file.info": "Dateiinformationen",
    "trainer.upload.file.name": "Dateiname:",
    "trainer.upload.file.size": "Größe:",
    "trainer.upload.file.type": "Typ:",
    "trainer.upload.data.analysis": "Datenanalyse",
    "trainer.upload.stats.samples": "Trainingsbeispiele",
    "trainer.upload.stats.input.length": "Durchschn. Eingabelänge",
    "trainer.upload.stats.output.length": "Durchschn. Ausgabelänge",
    "trainer.upload.stats.categories": "Kategorien",
    "trainer.upload.stats.quality": "Qualitätsbewertung",
    "trainer.upload.categories.found": "Gefundene Kategorien:",
    "trainer.upload.preview": "Datenvorschau (Erste 3 Zeilen)",
    "trainer.upload.preview.input": "Eingabe",
    "trainer.upload.preview.output": "Ausgabe",
    "trainer.upload.preview.category": "Kategorie",
    // Manuelle Eingabe
    "trainer.upload.manual.title": "Trainingsdaten manuell erstellen",
    "trainer.upload.manual.description": "Fügen Sie Trainingsbeispiele einzeln über das untenstehende Formular hinzu. Jedes Beispiel sollte einen Eingabeprompt und die erwartete Ausgabeantwort enthalten.",
    "trainer.upload.manual.input": "Eingabe (Prompt)",
    "trainer.upload.manual.input.placeholder": "Geben Sie den Prompt oder die Frage ein...",
    "trainer.upload.manual.output": "Ausgabe (Antwort)",
    "trainer.upload.manual.output.placeholder": "Geben Sie die erwartete Antwort ein...",
    "trainer.upload.manual.category": "Kategorie (Optional)",
    "trainer.upload.manual.category.placeholder": "Geben Sie ein Kategorie-Label ein...",
    "trainer.upload.manual.add": "Eintrag hinzufügen",
    "trainer.upload.manual.update": "Eintrag aktualisieren",
    "trainer.upload.manual.cancel": "Bearbeitung abbrechen",
    "trainer.upload.manual.edit": "Bearbeiten",
    "trainer.upload.manual.delete": "Löschen",
    "trainer.upload.manual.list.title": "Trainingsdaten-Einträge",
    "trainer.upload.manual.export": "Als CSV exportieren",
    "trainer.upload.manual.validation.required": "Eingabe- und Ausgabefelder sind erforderlich",
    "trainer.upload.manual.export.empty": "Keine Trainingsdaten zum Exportieren",
    // PDF Processing
    "trainer.upload.pdf.title": "PDF-Trainingsdaten-Generierung",
    "trainer.upload.pdf.description": "Ein PDF-Dokument hochladen, um automatisch Text zu extrahieren und nach Kapiteln organisierte Trainingsdaten zu generieren.",
    "trainer.upload.pdf.upload.title": "PDF-Dokument hochladen",
    "trainer.upload.pdf.select": "PDF-Datei auswählen",
    "trainer.upload.pdf.processing": "PDF wird verarbeitet...",
    "trainer.upload.pdf.extracting": "Kapitel werden extrahiert...",
    "trainer.upload.pdf.context.label": "Kontext (Optional)",
    "trainer.upload.pdf.context.placeholder": "Zusätzlichen Kontext zum Dokumentinhalt bereitstellen, um die Qualität der Trainingsdaten zu verbessern...",
    "trainer.upload.pdf.extract.button": "Kapitel extrahieren",
    "trainer.upload.pdf.chapters.title": "Extrahierte Kapitel",
    "trainer.upload.pdf.chapters.select": "Zu verarbeitende Kapitel auswählen:",
    "trainer.upload.pdf.chapters.selectall": "Alle auswählen",
    "trainer.upload.pdf.chapters.deselectall": "Alle abwählen",
    "trainer.upload.pdf.chapters.generate.button": "Trainingsdaten aus ausgewählten Kapiteln generieren",
    "trainer.upload.pdf.chapters.generating": "Trainingsdaten werden generiert...",
    "trainer.upload.pdf.chapters.preview": "Vorschau:",
    "trainer.upload.pdf.chapters.words": "Wörter",
    "trainer.upload.pdf.file.info": "PDF-Informationen",
    "trainer.upload.pdf.file.name": "Dateiname:",
    "trainer.upload.pdf.file.size": "Größe:",
    "trainer.upload.pdf.file.pages": "Seiten:",
    "trainer.upload.pdf.success": "Trainingsdaten erfolgreich generiert!",
    "trainer.upload.pdf.error": "Fehler beim Verarbeiten der PDF. Bitte versuchen Sie es erneut.",
    "trainer.upload.pdf.error.extraction": "Fehler beim Extrahieren der Kapitel aus der PDF",
    "trainer.upload.pdf.error.generation": "Fehler beim Generieren der Trainingsdaten",
    "trainer.upload.pdf.error.nofile": "Bitte wählen Sie eine PDF-Datei aus",
    "trainer.upload.pdf.error.nochapters": "Bitte wählen Sie mindestens ein Kapitel aus",
    // Config-Komponente
    "trainer.config.title": "Trainingskonfiguration",
    "trainer.config.basic": "Grundeinstellungen",
    "trainer.config.model.name": "Modellname",
    "trainer.config.model.name.required": "Modellname *",
    "trainer.config.model.name.placeholder": "Geben Sie einen eindeutigen Namen für Ihr Modell ein",
    "trainer.config.base.model": "Basismodell",
    "trainer.config.fine.tuning": "Trainingsmethode wählen",
    "trainer.config.fine_tuning.lora_extension": "LoRA Erweiterung",
    "trainer.config.fine_tuning.fulltrain": "Vollständiges Training",
    "trainer.config.advanced": "Erweiterte Einstellungen",
    "trainer.config.advanced.hide": "Verbergen",
    "trainer.config.advanced.show": "Anzeigen",
    "trainer.config.epochs": "Epochen",
    "trainer.config.epochs.help": "Anzahl der Trainingsiterationen (empfohlen: 10-50)",
    "trainer.config.learning.rate": "Lernrate",
    "trainer.config.learning.rate.help": "Steuert, wie schnell das Modell lernt (empfohlen: 0.001)",
    "trainer.config.batch.size": "Batch-Größe",
    "trainer.config.batch.size.help": "Anzahl der gemeinsam verarbeiteten Proben",
    "trainer.config.validation.split": "Validierungsaufteilung",
    "trainer.config.validation.split.help": "Prozentsatz der für Validierung verwendeten Daten (0,2 = 20%)",
    "trainer.config.train": "Training starten",
    // Progress-Komponente
    "trainer.progress.title": "Modelltraining",
    "trainer.progress.start": "Training starten",
    "trainer.progress.stop": "Training stoppen",
    "trainer.progress.new": "Neues Training",
    "trainer.progress.title.text": "Trainingsfortschritt",
    "trainer.progress.metric.epoch": "Aktuelle Epoche:",
    "trainer.progress.metric.loss": "Verlust:",
    "trainer.progress.metric.accuracy": "Genauigkeit:",
    "trainer.progress.metric.time": "Verbleibende Zeit:",
    // Results-Komponente
    "trainer.results.title": "Trainingsergebnisse",
    "trainer.results.success": "Training erfolgreich abgeschlossen!",
    "trainer.results.success.message": "Ihr benutzerdefiniertes Modell {modelName} wurde trainiert und ist einsatzbereit.",
    "trainer.results.metrics": "Endgültige Leistungsmetriken",
    "trainer.results.metric.loss": "Endgültiger Verlust",
    "trainer.results.metric.accuracy": "Endgültige Genauigkeit",
    "trainer.results.metric.epochs": "Abgeschlossene Epochen",
    "trainer.results.metric.samples": "Trainingsbeispiele",
    "trainer.results.export": "Modell exportieren",
    "trainer.results.deploy": "Modell bereitstellen",
    "trainer.results.test": "Modell testen",
    // Instructions-Komponente
    "trainer.instructions.title": "LLM Trainer Anweisungen",
    "trainer.instructions.subtitle": "Befolgen Sie diese Schritte, um Ihr benutzerdefiniertes Sprachmodell zu trainieren",
    "trainer.instructions.overview": "Überblick",
    "trainer.instructions.overview.text": "Dieses Tool hilft Ihnen dabei, große Sprachmodelle mit Ihren eigenen Trainingsdaten zu fine-tunen. Der Prozess umfasst vier Hauptschritte:",
    "trainer.instructions.step.upload": "Trainingsbeispiele im CSV-Format bereitstellen",
    "trainer.instructions.step.config": "Modellparameter und Trainingsoptionen festlegen",
    "trainer.instructions.step.monitor": "Ihr Modelltraining in Echtzeit beobachten",
    "trainer.instructions.step.review": "Ihr trainiertes Modell bewerten und bereitstellen",
    "trainer.instructions.data.requirements": "Datenanforderungen",
    "trainer.instructions.csv.format": "CSV-Format erforderlich",
    "trainer.instructions.csv.text": "Ihre Trainingsdaten müssen im CSV-Format mit diesen Spalten vorliegen:",
    "trainer.instructions.csv.input": "Der Prompt-/Fragetext (erforderlich)",
    "trainer.instructions.csv.output": "Die erwartete Antwort/Ausgabe (erforderlich)",
    "trainer.instructions.csv.category": "Klassifizierungskategorie (optional)",
    "trainer.instructions.example.csv": "Beispiel CSV-Daten:",
    "trainer.instructions.copy": "Kopieren",
    "trainer.instructions.backend.format": "Backend-Datenformat",
    "trainer.instructions.jsonl.format": "JSONL-Gesprächsformat",
    "trainer.instructions.jsonl.text": "Ihre CSV-Daten werden automatisch in das JSONL-Format für Fine-Tuning konvertiert:",
    "trainer.instructions.jsonl.example": "Generiertes JSONL-Format:",
    "trainer.instructions.format.notes": "Format-Hinweise:",
    "trainer.instructions.format.note1": "Jede Zeile enthält ein vollständiges Gespräch mit System-, Benutzer- und Assistentennachrichten",
    "trainer.instructions.format.note2": "Der System-Prompt hilft dabei, das Verhalten des Modells zu etablieren",
    "trainer.instructions.format.note3": "Die Benutzernachricht enthält Ihre Eingabedaten",
    "trainer.instructions.format.note4": "Die Assistentennachricht enthält Ihre erwartete Ausgabe",
    "trainer.instructions.best.practices": "Best Practices",
    "trainer.instructions.data.quality": "Datenqualität",
    "trainer.instructions.quality.tip1": "Verwenden Sie mindestens 50-100 hochwertige Beispiele",
    "trainer.instructions.quality.tip2": "Stellen Sie eine konsistente Formatierung und einen einheitlichen Stil sicher",
    "trainer.instructions.quality.tip3": "Vermeiden Sie doppelte oder widersprüchliche Beispiele",
    "trainer.instructions.quality.tip4": "Schließen Sie vielfältige Beispiele ein, die Ihren Anwendungsfall abdecken",
    "trainer.instructions.training.config": "Trainingskonfiguration",
    "trainer.instructions.config.tip1": "Beginnen Sie mit 3-5 Epochen für erste Tests",
    "trainer.instructions.config.tip2": "Verwenden Sie eine Lernrate von 0,0001 für die meisten Fälle",
    "trainer.instructions.config.tip3": "Setzen Sie die Validierungsaufteilung auf 20% für die Überwachung",
    "trainer.instructions.config.tip4": "Wählen Sie aussagekräftige Modellnamen",
    "trainer.instructions.model.selection": "Modellauswahl",
    "trainer.instructions.selection.tip1": "Verwenden Sie Instruktionsmodelle für Gesprächsaufgaben",
    "trainer.instructions.selection.tip2": "Beginnen Sie mit kleineren Modellen (8B) zum Testen",
    "trainer.instructions.selection.tip3": "Erwägen Sie größere Modelle (70B) für komplexe Aufgaben",
    "trainer.instructions.selection.tip4": "Aktivieren Sie LoRA-Fine-Tuning für Effizienz",
    "trainer.instructions.monitoring": "Überwachung",
    "trainer.instructions.monitor.tip1": "Beobachten Sie, wie die Verlustwerte mit der Zeit abnehmen",
    "trainer.instructions.monitor.tip2": "Überwachen Sie Validierungsmetriken auf Überanpassung",
    "trainer.instructions.monitor.tip3": "Stoppen Sie früh, wenn der Validierungsverlust steigt",
    "trainer.instructions.monitor.tip4": "Testen Sie Ihr Modell nach dem Training gründlich",
    "trainer.instructions.troubleshooting": "Fehlerbehebung",
    "trainer.instructions.trouble.upload": "Datei-Upload fehlgeschlagen",
    "trainer.instructions.upload.fix1": "Überprüfen Sie, ob Ihre Datei im CSV-Format vorliegt",
    "trainer.instructions.upload.fix2": "Stellen Sie sicher, dass die erforderlichen Spalten (Eingabe, Ausgabe) vorhanden sind",
    "trainer.instructions.upload.fix3": "Überprüfen Sie, ob das CSV korrekt mit Kopfzeilen formatiert ist",
    "trainer.instructions.upload.fix4": "Versuchen Sie kleinere Dateigrößen (unter 10MB)",
    "trainer.instructions.trouble.validation": "Validierungsfehler",
    "trainer.instructions.validation.fix1": "Überprüfen Sie auf leere Eingabe- oder Ausgabefelder",
    "trainer.instructions.validation.fix2": "Entfernen oder reparieren Sie fehlerhafte CSV-Zeilen",
    "trainer.instructions.validation.fix3": "Stellen Sie eine konsistente Spaltenstruktur sicher",
    "trainer.instructions.validation.fix4": "Überprüfen Sie, ob Sonderzeichen korrekt maskiert sind",
    "trainer.instructions.trouble.slow": "Training zu langsam",
    "trainer.instructions.slow.fix1": "Reduzieren Sie die Anzahl der Epochen",
    "trainer.instructions.slow.fix2": "Verwenden Sie kleinere Batch-Größen",
    "trainer.instructions.slow.fix3": "Wählen Sie ein kleineres Basismodell",
    "trainer.instructions.slow.fix4": "Aktivieren Sie LoRA-Fine-Tuning",
    "trainer.instructions.trouble.performance": "Schlechte Modellleistung",
    "trainer.instructions.performance.fix1": "Erhöhen Sie die Menge der Trainingsdaten",
    "trainer.instructions.performance.fix2": "Verbessern Sie Datenqualität und Konsistenz",
    "trainer.instructions.performance.fix3": "Passen Sie die Lernrate an (versuchen Sie 0,00001)",
    "trainer.instructions.performance.fix4": "Trainieren Sie für mehr Epochen",
    "trainer.instructions.ready": "Bereit zu starten?",
    "trainer.instructions.ready.text": "Sobald Sie die Anforderungen verstehen:",
    "trainer.instructions.ready.step1": "Bereiten Sie Ihre CSV-Datei mit Eingabe-/Ausgabe-Paaren vor",
    "trainer.instructions.ready.step2": "Klicken Sie oben auf den Tab \"Daten hochladen\", um zu beginnen",
    "trainer.instructions.ready.step3": "Folgen Sie dem geführten Workflow durch jeden Schritt",
    "trainer.instructions.ready.step4": "Überwachen Sie Ihren Trainingsfortschritt",
    "trainer.instructions.ready.step5": "Testen und stellen Sie Ihr trainiertes Modell bereit",
    "trainer.instructions.good.luck": "Viel Erfolg beim Training Ihres Modells! 🎉",
    "chat.config.deep.search.checkbox.label": "Tiefensuche verwenden",
    "chat.config.adv.prompt.checkbox.label": "Erweiterte Eingabeaufforderungen",
    "chat.config.autocomplete.style.selected": "Stil \"{name}\" wurde hinzugefügt",
    "chat.config.autocomplete.project.selected": "Projekt \"{name}\" wurde hinzugefügt",
    "chat.config.autocomplete.knowledge.selected": "Wissen \"{name}\" wurde hinzugefügt",
    "chat.sync.model.button": "Modell Synchronisieren",
    "chat.sync.model.tooltip": "Mit Konversationsmodell synchronisieren",
    "training_jobs.list": "Trainingsjobs",
    // CodeViewerComponent translations
    "code-viewer.show_code": "Code anzeigen",
    "code-viewer.hide_code": "Code ausblenden",
    "code-viewer.writing_code": "Code wird geschrieben",
    // Branch translations
    'route.branches': 'Bereiche',
    'branch.name': 'Name',
    'branch.description': 'Beschreibung',
    'branch.color': 'Farbe',
    'branch.create': 'Bereich Erstellen',
    // Branch form page
    'branch.form.error.load_failed': "Fehler beim Laden des Bereichs",
    'branch.form.error.action_failed': "Aktion fehlgeschlagen",
    'branch.form.error.general_error': "Ein Fehler ist aufgetreten",
    'branch.form.action.updated': "aktualisiert",
    'branch.form.action.created': "erstellt",
    'branch.form.action.update': "aktualisieren",
    'branch.form.action.create': "erstellen",
    'branch.form.success.updated': "Bereich erfolgreich aktualisiert",
    'branch.form.success.created': "Bereich erfolgreich erstellt",
    'branch.form.success.action_completed': "Aktion abgeschlossen",
    // Profession translations
    'route.professions': 'Berufe',
    'profession.name': 'Name',
    'profession.description': 'Beschreibung',
    'profession.branch': 'Bereich',
    'profession.create': 'Beruf Erstellen',
    'profession.common': 'Allgemein',
    'profession.creator': 'Ersteller',
    // Step translations
    'route.steps': 'Schritte',
    'step.title': 'Titel',
    'step.description': 'Beschreibung',
    'step.order': 'Reihenfolge',
    'step.isShared': 'Geteilt',
    'step.profession': 'Beruf',
    'step.create': 'Schritt erstellen',
    // Step form page
    'step.creator': 'Ersteller',
    // Question form (question manager)
    // Question types
    // Question translations
    'route.questions': 'Fragen',
    'question.title': 'Titel',
    'question.description': 'Beschreibung',
    'question.type': 'Typ',
    'question.required': 'Erforderlich',
    'question.order': 'Reihenfolge',
    'question.step': 'Schritt',
    'question.create': 'Frage erstellen',
    // Onboarding translations
    'route.onboardings': 'Onboarding',
    // Onboarding intro
    'onboarding.avatar': 'Avatar',
    'onboarding.profession': 'Beruf',
    'onboarding.status': 'Status',
    'onboarding.currentStep': 'Aktueller Schritt',
    'onboarding.createdAt': 'Erstellt',
    'onboarding.create': 'Onboarding starten',
    // Onboarding Wizard translations
    // Onboarding Component
    'onboarding.title': 'Onboarding',
    'onboarding.loading': 'Laden...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    'knowledge': 'Wissen',
    // Additional onboarding translations
    'onboarding.filter': 'Filter',
    'onboarding.progress': 'Fortschritt',
    'onboarding.createdBy': 'Erstellt von',
    'pagination.previous': 'Zurück',
    'pagination.next': 'Weiter',
    'actions': 'Aktionen',
    'view': 'Anzeigen',
    'edit': 'Bearbeiten',
    'delete': 'Löschen',
    'loading': 'Laden...',
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': 'Felder ausgefüllt',
    // Login page specific keys
    // Register page specific keys
    // Registration Complete page
    // Account Activation page
    // Settings translations
    'settings.saveButton': 'Einstellungen speichern',
    'settings.savedSuccessfully': 'Einstellungen erfolgreich gespeichert',
    'settings.failedToSave': 'Fehler beim Speichern der Einstellungen',
    'settings.failedToLoad': 'Fehler beim Laden der Einstellungen',
    // Settings Tabs
    // General Settings - Chat Learning
    // RAG Settings
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // Google Drive Settings
    // Google Drive File Picker
    // Google Drive Directory Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Resource translations
    'resource.active': 'Aktiv',
    // Generated Image Component
    'gen-image.noData': 'Keine Bilddaten bereitgestellt',
    'gen-image.invalidData': 'Ungültiges Bilddatenformat',
    'gen-image.loadError': 'Fehler beim Laden des Bildes',
    'gen-image.loading': 'Bild wird geladen...',
    'gen-image.altText': 'Generiertes Bild',
    'gen-image.download': 'Herunterladen',
    'gen-image.copyToClipboard': 'In Zwischenablage kopieren',
    // File Card Component
    'file-card.errorLoading': 'Fehler beim Laden der Datei',
    'file-card.unknownFile': 'Unbekannte Datei',
    'file-card.unknownSize': 'Unbekannte Größe',
    'file-card.download': 'Herunterladen',
    'file-card.addToKdb': 'Zur Wissensdatenbank hinzufügen',
    'file-card.videoNotSupported': 'Ihr Browser unterstützt das Video-Tag nicht.',
    'file-card.zoomHint': 'zum Vergrößern klicken',
    'file-card.zoom': 'Vergrößern',
    'file-card.close': 'Schließen',
    // Reports and Cost Analytics
    'reports.totalCost': 'Gesamtkosten',
    'reports.totalMessages': 'Nachrichten gesamt',
    'reports.avgCostPerMessage': 'Ø Kosten/Nachricht',
    'reports.totalTokens': 'Token gesamt',
    'reports.filters': 'Filter',
    'reports.startDate': 'Startdatum',
    'reports.endDate': 'Enddatum',
    'reports.userName': 'Benutzername',
    'reports.companyName': 'Firmenname',
    'reports.userNamePlaceholder': 'Nach Benutzername filtern...',
    'reports.companyNamePlaceholder': 'Nach Firmenname filtern...',
    'reports.avatarNamePlaceholder': 'Nach Avatar-Name filtern...',
    'reports.date': 'Datum',
    'reports.promptTokens': 'Prompt-Token',
    'reports.completionTokens': 'Vervollständigungs-Token',
    'reports.cost': 'Kosten',
    'reports.cost_type': 'Anfragetyp',
    'reports.company': 'Unternehmen',
    'reports.upstreamCost': 'Upstream-Kosten',
    'reports.reasoningTokens': 'Reasoning-Token',
    'reports.cachedTokens': 'Zwischengespeicherte Token',
    'reports.noData': 'Keine Kostendaten verfügbar',
    'reports.noDataDescription': 'Keine Nutzungskostendaten für die ausgewählten Kriterien gefunden.',
    'reports.failedToLoad': 'Kostendaten konnten nicht geladen werden',
    'reports.loadingError': 'Fehler beim Laden der Kostendaten',
    'reports.user': 'Benutzer',
    'reports.costTrends': 'Kosten- & Token-Trends',
    'reports.showChart': 'Diagramm anzeigen',
    'reports.tokens': 'Token',
    'report.usage_cost_data': 'Nutzungskostendaten',
    'reports.userSummary': 'Benutzer-Zusammenfassungsstatistiken',
    'reports.avatarUsage': 'Avatar-Nutzungsstatistiken',
    'reports.messageCount': 'Nachrichten',
    'reports.avgTokensPerMessage': 'Durchschn. Token/Nachricht',
    'reports.firstUsage': 'Erste Nutzung',
    'reports.lastUsage': 'Letzte Nutzung',
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': 'Vollständiger Dokumentenscan fügt die gesamte Datei zur Eingabe hinzu, was zu teureren und längeren Antworten führt',
    // Icon Picker
    'iconPicker.selectIcon': 'Symbol auswählen',
    'iconPicker.clear': 'Auswahl löschen',
    'iconPicker.searchPlaceholder': 'Symbole suchen...',
    'iconPicker.noResults': 'Keine Symbole gefunden',
    'iconPicker.resultsLimited': 'Ergebnisse auf 100 Symbole begrenzt. Verwenden Sie die Suche, um die Auswahl einzugrenzen.',
    // AI Assistant Context
    'context.userMessages': 'Benutzernachrichten',
    'context.assistantMessages': 'Assistentennachrichten',
    'context.activeEntries': 'aktive Einträge',
    'context.summary': 'Kontext',
    'context.empty': 'Kein Kontext verfügbar',
    'context.validationError': 'Kontext-Validierungsfehler',
    // Autocomplete Triggers Component
    // Berichte
    'and': 'und',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': 'Firmeneinstellungen und -informationen verwalten',
    'acl_resource_desc.user': 'Benutzerkonten und Profile verwalten',
    'acl_resource_desc.user_group': 'Benutzergruppen und deren Berechtigungen verwalten',
    'acl_resource_desc.settings_general': 'Zugriff auf allgemeine Anwendungseinstellungen',
    'acl_resource_desc.settings_access': 'Zugriffskontrolle und Sicherheitseinstellungen verwalten',
    'acl_resource_desc.settings_styles': 'Schreibstile und Vorlagen verwalten',
    'acl_resource_desc.avatar': 'KI-Avatare und Assistenten erstellen und verwalten',
    'acl_resource_desc.ai': 'Zugriff auf KI-Modelle und -Konfigurationen',
    'acl_resource_desc.knowledge': 'Wissensdatenbank und Informationsressourcen verwalten',
    'acl_resource_desc.project': 'Projekte und Arbeitsabläufe erstellen und verwalten',
    'acl_resource_desc.onboarding': 'Benutzer-Onboarding-Prozesse und -Vorlagen verwalten',
    'acl_resource_desc.reports': 'Systemberichte und Analysen erstellen und anzeigen',
    // ACL Action Descriptions
    'acl_action_desc.read': 'Informationen einsehen und darauf zugreifen, ohne Änderungen vorzunehmen',
    'acl_action_desc.write': 'Inhalte und Einstellungen erstellen, bearbeiten und ändern',
    'acl_action_desc.delete': 'Elemente aus dem System entfernen und dauerhaft löschen',
    // V-Select Component
    "v-select.createNew": "Neu erstellen",
    "v-select.noOptions": "Keine Optionen verfügbar",
    // Keyboard shortcuts
    'shortcuts.title': 'Tastenkombinationen',
    'shortcuts.tooltip-text': 'Verfügbare Tastenkombinationen anzeigen',
    // Routes
    'route.passwordReset': 'Passwort zurücksetzen',
    'route.passwordResetConfirm': 'Passwort zurücksetzen',
    'route.registerComplete': 'Registrierung abgeschlossen',
    'route.activateAccount': 'Konto aktivieren',
    // Currency
    // Navigation
    'nav.credits': 'Kredite',
    // Tools
    'tools.toolLabel': 'Werkzeug',
    'tools.activeTools': 'Aktive Werkzeuge',
    'tools.expandAll': 'Alle erweitern',
    'tools.collapseAll': 'Alle einklappen',
    'tools.unknownTool': 'Unbekanntes Werkzeug',
    'tools.noActiveTools': 'Keine aktiven Werkzeuge',
    'tools.webSearch': 'Websuche',
    'tools.rag': 'Wissensbasis',
    'webSearch.searching': 'Suche im Web nach',
    'webSearch.toolData': 'Websuchdaten',
    'webSearch.searchingFor': 'Suche nach',
    'webSearch.resultsFound': 'Ergebnisse gefunden',
    'webSearch.noResultsFound': 'Keine Ergebnisse gefunden',
    'webSearch.tryDifferentQuery': 'Versuchen Sie eine andere Suchanfrage',
    'rag.searchingKnowledge': 'Wissensbasis durchsuchen',
    'rag.open_knowledge_preview': 'Wissensvorschau öffnen',
    'rag.openInKnowledgeBase': 'Vorschau',
    'rag.noFilesIncluded': 'Keine Dateien enthalten',
    'rag.sources_used': 'Verwendete Quellen',
    'rag.sources': 'Quellen',
    'rag.open_sources': 'Quellen anzeigen',
    // Product Cards
    'productCard.toolData': 'Produktkarten',
    'productCard.productList': 'Produktliste',
    'productCard.singleProduct': 'Einzelprodukt',
    'productCard.product': 'Produkt',
    'productCard.products': 'Produkte',
    'productCard.grossPrice': 'Bruttopreis',
    'productCard.netPrice': 'Nettopreis',
    'productCard.vat': 'MwSt',
    'productCard.category': 'Kategorie',
    'productCard.viewProduct': 'Produkt ansehen',
    'productCard.noProducts': 'Keine Produkte gefunden',
    'productCard.trySearching': 'Versuchen Sie, nach Produkten zu suchen',
    // Product Compare Tool
    'productCompare.domain': 'Domain',
    'productCompare.comparing': 'Vergleich',
    'productCompare.searchQuery': 'Suchanfrage',
    'productCompare.noResults': 'Keine Vergleichsergebnisse gefunden',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': 'Telefonnummern',
    'detectContactData.emails': 'E-Mails',
    'detectContactData.addresses': 'Adressen',
    'detectContactData.names': 'Namen',
    'detectContactData.companies': 'Unternehmen',
    'detectContactData.socialMedia': 'Soziale Medien',
    'detectContactData.websites': 'Webseiten',
    'detectContactData.other': 'Sonstiges',
    'detectContactData.noData': 'Keine Kontaktdaten erkannt',
    // Detect Tasks Tool
    'detectTasks.notes': 'Notizen',
    'detectTasks.noTasks': 'Keine Aufgaben erkannt',
    // Offer Creator Tool
    'offerCreator.companyName': 'Firmenname',
    'offerCreator.firstName': 'Vorname',
    'offerCreator.lastName': 'Nachname',
    'offerCreator.email': 'E-Mail',
    'offerCreator.phone': 'Telefon',
    'offerCreator.vatPayer': 'Umsatzsteuerzahler',
    'offerCreator.employeesNumber': 'Mitarbeiteranzahl',
    'offerCreator.businessActivity': 'Geschäftstätigkeit',
    'offerCreator.taxationType': 'Besteuerungsart',
    'offerCreator.documentsNumber': 'Anzahl der Dokumente',
    'offerCreator.packageId': 'Paket',
    'offerCreator.additionalInfo': 'Zusätzliche Informationen',
    'offerCreator.formSent': 'Formular gesendet',
    'offerCreator.noData': 'Keine Angebotsdaten gesammelt',
    // Quick Offer Tool
    'quickOffer.availableOptions': 'Verfügbare Optionen',
    'quickOffer.formSent': 'Formular gesendet',
    'quickOffer.noFields': 'Keine Formularfelder',
    // Send Contact Form Tool
    'sendContactForm.name': 'Name',
    'sendContactForm.email': 'E-Mail',
    'sendContactForm.phone': 'Telefon',
    'sendContactForm.message': 'Nachricht',
    'sendContactForm.formSent': 'Kontaktformular gesendet',
    'sendContactForm.noData': 'Keine Kontaktformulardaten',
    // Conversation Tags Tool
    'convoTags.noTags': 'Keine Tags erkannt',
    // Gallery Tags Tool
    'galleryTags.noTags': 'Keine Galerie-Tags erkannt',
    // Ask For Voucher Tool
    'askForVoucher.detected': 'Gutscheinanfrage erkannt',
    'askForVoucher.notDetected': 'Keine Gutscheinanfrage erkannt',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': 'Angebote signalisiert',
    'dynamicListings.allListings': 'Alle Angebote signalisiert',
    // Product API Search Tool
    'productAPISearch.searchQuery': 'Suchanfrage',
    'productAPISearch.totalResults': 'Gesamtergebnisse',
    'productAPISearch.subcategories': 'Unterkategorien',
    'productAPISearch.noResults': 'Keine Ergebnisse gefunden',
    // Google Drive  
    // Knowledge Bulk Upload
    // Avatar RAG Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // DB Logs page
    'dblogs.title': 'DB Audit-Protokolle',
    'dblogs.show': 'Anzeigen',
    'dblogs.hide': 'Ausblenden',
    'dblogs.empty': 'Keine Protokolleinträge gefunden.',
    // DB model collection names
    'model.user': 'Benutzer',
    'model.user_group': 'Benutzergruppe',
    'model.api_keys': 'API-Schlüssel',
    'model.acl_policy': 'ACL-Richtlinie',
    'model.company': 'Unternehmen',
    'model.conversation': 'Gespräch',
    'model.message': 'Nachricht',
    'model.avatar': 'Avatar',
    'model.user_avatar': 'Benutzer-Avatar',
    'model.knowledge': 'Wissen',
    'model.knowledgeGroup': 'Wissensgruppe',
    'model.file': 'Datei',
    'model.training_job': 'Trainingsauftrag',
    'model.avatar_knowledge': 'Avatar-Wissen',
    'model.avatar_instruction': 'Avatar-Anweisung',
    'model.avatar_instruction_version': 'Avatar-Anweisungsversion',
    'model.profession_knowledge': 'Berufswissen',
    'model.profession_step': 'Berufsschritt',
    'model.custom_models': 'Benutzerdefiniertes Modell',
    'model.embeddings': 'Einbettung',
    'model.branch': 'Zweig',
    'model.profession': 'Beruf',
    'model.step': 'Schritt',
    'model.step_profession': 'Berufsschritt',
    'model.onboarding': 'Onboarding',
    'model.db_logs': 'DB-Protokoll',
    'model.question': 'Frage',
    'model.answer': 'Antwort',
    'model.settings': 'Einstellungen',
    'model.usage_cost': 'Nutzungskosten',
    'model.knowledge_elevenlabs_mappings': 'ElevenLabs-Wissens-Zuordnung',
    'model.front_sync': 'Frontend-Synchronisation',
    'model.favorite_conversation': 'Lieblingskonversation',
    'model.style': 'Stil',
    'model.slotData': 'Slot-Daten',
    'model.payments': 'Zahlung',
    'model.account_balance': 'Kontostand',
    'model.accountGrade': 'Kontoniveau',
    'model.currencyRate': 'Wechselkurs',
    'model.test_result': 'Testergebnis',
    'model.bot_test': 'Bot-Test',
    'model.bot_test_tester': 'Bot-Test-Tester',
    'model.bot_test_target': 'Bot-Test-Ziel',
    'model.tutorial': 'Tutorial',
    'model.tutorial_step': 'Tutorial-Schritt',
    'model.tutorial_section': 'Tutorial-Abschnitt',
    'model.tutorial_section_knowledge': 'Tutorial-Abschnitt-Wissen',
    'model.tutorial_section_todo': 'Tutorial-Abschnitt-Todo',
    'model.tutorial_participants': 'Tutorial-Teilnehmer',
    'model.todo': 'Todo',
    'model.todo_item': 'Todo-Element',
    'model.todo_item_value': 'Todo-Element-Wert',
    'model.cache': 'Cache',
    'model.api_tool_definition': 'API-Tool-Definition',
    // DB operation names
    // WhatsApp settings
    "route.settings.comms": "Kommunikation",
    "route.settings.comms.create": "Kommunikation erstellen",
    "route.settings.comms.edit": "Kommunikation bearbeiten",
    "route.settings.comms.manage": "Kommunikation verwalten",
    "route.settings.comms.group": "Gruppendetails",
    "route.settings.comms.group.create": "Gruppe erstellen",
    "route.settings.comms.dm": "Direktnachrichten-Kontakt",
    'socialMediaPlan.title': 'Content Studio',
    'socialMediaPlan.failedToLoad': 'Beiträge konnten nicht geladen werden',
    'socialMediaPlan.newPost': 'Neuer Beitrag', 'socialMediaPlan.library': 'Bibliothek', 'socialMediaPlan.search': 'Beitrag suchen...', 'socialMediaPlan.edit': 'Bearbeiten', "socialMediaPlan.schedule.action": 'Was weiter?', 'socialMediaPlan.back': 'Zurück', 'socialMediaPlan.next': 'Weiter', 'socialMediaPlan.cancel': 'Abbrechen', 'socialMediaPlan.save': 'Bestätigen & speichern', 'socialMediaPlan.close': 'Schließen',
    'whatsapp.loginFailed': 'WhatsApp-Anmeldung fehlgeschlagen.',
    'whatsapp.logoutSuccess': 'WhatsApp erfolgreich abgemeldet.',
    'whatsapp.logoutFailed': 'WhatsApp-Abmeldung fehlgeschlagen.',
    'whatsapp.failedToLoad': 'WhatsApp-Status konnte nicht geladen werden.',
    'whatsapp.entityIdRequired': 'Entitäts-ID ist erforderlich.',
    'whatsapp.phoneRequired': 'Telefonnummer ist erforderlich.',
    'whatsapp.settingsSaved': 'WhatsApp-Einstellungen erfolgreich gespeichert.',
    'whatsapp.settingsSaveFailed': 'WhatsApp-Einstellungen konnten nicht gespeichert werden.',
    'whatsapp.agentStarted': 'WhatsApp-Agent erfolgreich gestartet.',
    'whatsapp.agentStartFailed': 'WhatsApp-Agent konnte nicht gestartet werden.',
    'whatsapp.agentStopped': 'WhatsApp-Agent erfolgreich gestoppt.',
    'whatsapp.agentStopFailed': 'WhatsApp-Agent konnte nicht gestoppt werden.',
    // WhatsApp group
    // WhatsApp track logs
    // Activity panels
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp direct messages
    // WhatsApp DM detail page
    // Email Reporting (POP3) Settings
    'whatsapp.pop3SettingsSaved': 'E-Mail-Berichtseinstellungen erfolgreich gespeichert.',
    'whatsapp.pop3SettingsSaveFailed': 'E-Mail-Berichtseinstellungen konnten nicht gespeichert werden.',
    // Gmail OAuth
    // ACL translations
    ...de_1.aclTranslationsDe
};
exports.default = de;
